export default {
    spanish: 'Español',
    english: 'Inglés',
    addPrinter: {
      title: "Agregar Impresora",
      detectPrinters: "Detectar Impresoras Automáticamente",
      printerName: "Nombre de la Impresora",
      printerType: "Tipo de Impresora",
      laser: "Impresora Láser",
      receipt: "Impresora de Recibos",
      barcode: "Impresora de Códigos de Barras",
      connectionType: "Tipo de Conexión",
      network: "Red",
      ipAddress: "Dirección IP",
      port: "Puerto",
      driverType: "Tipo de Controlador",
      printSpeed: "Velocidad de Impresión",
      autoCutter: "Cortador Automático",
      cashDrawerPort: "Puerto del Cajón de Dinero",
      printDensity: "Densidad de Impresión",
      savePrinter: "Guardar Impresora",
      detectionCompleted: "Detección de impresora completada.",
      fillAllFields: "Por favor, complete todos los campos requeridos.",
      success: "¡Impresora agregada con éxito!",
      scanning: "Escaneando en busca de impresoras...",
      detectionSuccess: "¡Impresora detectada con éxito!",
      noPrintersFound: "No se encontraron impresoras.",
      detectionError: "Error al detectar impresoras."
    },    
    backoffice: {
      printerManager: {
        title: "Administrador de impresoras",
        printers: "Impresoras",
        select: "Seleccionar",
        discoverPrinters: "Buscar impresoras",
        showAddPrinter: "Agregar impresora",
        printTest: "Imprimir página de prueba",
        scanBluetooth: "Buscar impresoras Bluetooth",
        printerName: "Nombre de la impresora",
        printerType: "Tipo de impresora",
        laser: "Impresora láser (A4)",
        receipt: "Impresora de recibos",
        barcode: "Impresora de códigos de barras",
        autoCutter: "Cortador automático",
        driverType: "Tipo de controlador",
        connectionType: "Tipo de conexión",
        ipAddress: "Dirección IP",
        port: "Puerto",
        mac: "Dirección MAC",
        isDefault: "Predeterminado",
        add: "Agregar",
        cancel: "Cancelar",
        noPrintersFound: "No se encontraron impresoras.",
        printSentSuccess: "Impresión enviada correctamente a la impresora de red.",
        printFailedBackend: "La impresión falló en el backend.",
        networkPrintError: "Error de impresión en red: {error}",
        usbPrintError: "Error de impresión USB. ¡Verifique las conexiones!",
        noUSBPrinters: "¡No se detectaron impresoras USB!",
        bluetoothPrintError: "Error de impresión Bluetooth. ¡Verifique la conexión!",
        printFailed: "La impresión falló. Por favor, revise la conexión de la impresora e intente de nuevo.",
        selectPrinterType: "Seleccionar Printer Connection Type",
        inputPlaceholder: "Seleccionar a type connection",
        pleaseSelectPrinterType: "Por favor, seleccione un tipo de impresora.",
        invalidPrinterType: "Tipo de impresora seleccionado no válido.",
        scannedFromBLE: "Escaneado desde BLE: {barcode}"
      },
      bleScanner: {
        title: "Escáner y impresora BLE",
        deviceType: "Tipo de dispositivo",
        scanner: "Escáner de códigos de barras",
        printer: "Impresora",
        scanDevices: "Buscar dispositivos BLE",
        unnamedDevice: "Dispositivo sin nombre",
        connect: "Conectar",
        scannedBarcode: "Código de barras escaneado:",
        printData: "Datos de impresión",
        enterPrintText: "Ingrese texto para imprimir",
        sendToPrinter: "Enviar a la impresora",
        bleScanError: "Error de escaneo BLE: {error}",
        connectionSuccess: "Conectado a {device}",
        connectionError: "Error de conexión: {error}",
        notificationError: "Error de notificación: {error}",
        scanned: "Escaneado: {barcode}",
        noPrinterOrData: "No hay impresora conectada o los datos de impresión están vacíos.",
        printDataSent: "Datos de impresión enviados a la impresora.",
        printError: "Error de impresión: {error}"
      },
      interactions: {
        lastContacted: 'Ultimo Contacto',
        notesLastContacted: 'Notas Ultimo Contacto',
        nextFollowUp: 'Siguiente Seguimiento',
        notesNextFollowUp: 'Notas Siguiente Seguimiento',
        preferredContactTime: 'Tiempo Preferido de Contacto',
        notesContactToTime: 'Notas Tiempo Preferido de Contacto',
        selectSubscriber: 'Seleccionar Suscriptor',
        selectSubscriberDescription: 'Seleccionar un suscriptor para agregar o ver su información',
        selectSubscriberInput: 'Seleccionar un suscriptor',
        selectSubscriberInputPlaceholder: 'Seleccionar un suscriptor',
        createSubscriber: 'Crear Suscriptor',
        cancel: 'Cancelar',
        //customers
        selectCustomer: 'Seleccionar Cliente',
        selectCustomerDescription: 'Seleccionar un cliente para agregar o ver su información',
        selectCustomerInput: 'Seleccionar un cliente',
        selectCustomerInputPlaceholder: 'Seleccionar un cliente',
        createCustomer: 'Crear Cliente',
      },
      cCardSaved:{
        paymentManagement: 'Gestión de pagos',
        clickToManageCards: 'Haz clic aquí para agregar o ver tus tarjetas registradas',
        creditCards: 'Tarjetas de crédito',
        addCreditCard: 'Agregar tarjeta de crédito',
      },
      virtualTerminal: {
        acordeon1: {
          title: 'Información de pago/autorización',
          subtitle:
            'Aceptar Método de pago American Express, Discover Mastercard',
          cardNumber: 'Numero de tarjeta',
          expirationDate: 'Fecha de expiración',
          amount: 'Monto'
        },
        acordeon2: {
          title: 'Información del pedido',
          subscriptionName: 'Nombre de Suscripción',
          invoice: 'Factura #',
          description: 'Descripción',
          placeholder: 'Escribe más información aqui...'
        },
        acordeon3: {
          title: 'Intervalo de suscripción',
          subtitle:
            'Selecciona la frecuencia con la que factura el servicio de atención al cliente.',
          selectOption: 'Seleccionar opción',
          interval1: 'Mensual',
          interval2: 'Trimestral',
          interval3: 'Semi anual',
          interval4: 'Anualmente'
        },
        acordeon4: {
          title: 'Duración de la suscripción',
          startDate: 'Fecha de inicio',
          noEnd: 'Sin fecha de finalización (suscripción en curso)',
          endDate: 'Fecha final',
          endAfter: 'Terminar después'
        },
        acordeon5: {
          title: 'Pago',
          nameAcount: 'Nombre de la cuenta',
          paymentType: 'Tipo de pago',
          creditCard: 'Tarjeta de credito',
          subscriptionName: 'Nombre de suscripción',
          trialAmount: 'Cantidad de prueba',
          firstName: 'Primer Nombre',
          sameAsBilling: 'Igual que la facturación'
        }
      },
      worksheetStatus: {
        draft: 'Borrador',
        opened: 'Abierta',
        closed: 'Cerrada',
        worksheetDetail: 'Detalles de la hoja de trabajo',
        fields: {
          responsable: 'Responsable',
          startDate: 'Fecha de Inicio',
          endDate: 'Fecha de Fin',
          workers: 'Trabajadores'
        },
        tooltip: {
          staffWorker: 'Añadir trabajadores',
          resetAllCalendar: 'Reiniciar todos los calendarios',
          showCalendarDetails: 'Mostrar detalles del calendario',
          resetCalendar: 'Reiniciar calendario',
          removeStaffWorker: 'Remove staff worker',
          debit: 'Estos son tus gastos. Dinero que se paga.',
          credit: 'Estos son tus ingresos. Dinero que recibes.',
          payee: 'Este es quien te pagó o a quien pagaste.',
          category: 'Este es el tipo de pago o ingreso.',
          bestRepresentation: 'Esta es la mejor suposición del sistema para la categoría.'    
        },
        message: {
          totalHour: 'Total de horas trabajadas:',
          hours: 'horas',
          with: 'con',
          minutes: 'minutos'
        },
        button: {
          saveDraft: 'Guardar Borrador',
          saveOpen: 'Guardar y Abrir',
          close: 'Cerrar',
          addShift: 'Agregar turno',
          changeworksheetRequest: 'Solicitud de cambio'
        }
      },
      mastercard:{
        accountInfo: 'Información de cuenta',
        mastercardUserDetails: 'Detalles de Usuario de Mastercard',
        seeLinedAccounts: 'Ver Cuentas Vinculadas',
        addMoreBanks: 'Agregar más Bancos',
        linkedBanks: 'Cuentas Vinculadas',
        viewTransactions: 'Ver Transacciones',
        linesPerPage: 'Cuantas lineas por pagina',
      },
      transactionData: {
        revenue: "Ingresos",
        revenueDescription: "Activa este interruptor si la transacción es una entrada de ingresos.",
        transactionId: "ID de transacción",
        transactionIdDescription: "Introduce el ID único de la transacción asociada con esta transacción.",
        transactionAmount: "Monto de la transacción (USD)",
        transactionAmountDescription: "Introduce el monto de la transacción en USD. Este es el monto involucrado en la transacción.",
        accountId: "ID de cuenta",
        accountIdDescription: "Introduce el ID único de la cuenta asociada con la transacción.",
        customerId: "ID de cliente",
        customerIdDescription: "Introduce el ID único del cliente asociado con la transacción.",
        transactionStatus: "Estado de la transacción",
        transactionStatusDescription: "Selecciona el estado actual de la transacción de las opciones disponibles.",
        statusOptions: {
          active: "Activo",
          pending: "Pendiente",
          completed: "Completado",
          failed: "Fallido",
          cancelled: "Cancelado"
        },
        memo: "Memo",
        memoDescription: "Introduce cualquier nota adicional o memo para la transacción.",
        transactionType: "Tipo de transacción",
        transactionTypeDescription: "Selecciona el tipo de transacción para esta transacción.",
        transactionDate: "Fecha de la transacción",
        transactionDateDescription: "Selecciona la fecha en la que ocurrió la transacción.",
        typeOptions: {
          debit: "Débito",
          credit: "Crédito",
          transfer: "Transferencia",
          payment: "Pago",
          withdrawal: "Retiro",
          deposit: "Depósito"
        },
        postedDate: "Fecha de publicación",
        postedDateDescription: "Selecciona la fecha en la que se publicó la transacción.",
        createdDate: "Fecha de creación",
        createdDateDescription: "Selecciona la fecha en la que se creó la transacción.",
        firstEffectiveDate: "Primera fecha efectiva",
        firstEffectiveDateDescription: "Selecciona la primera fecha efectiva de la transacción.",
        effectiveDate: "Fecha efectiva",
        effectiveDateDescription: "Selecciona la fecha efectiva de la transacción.",
        optionExpireDate: "Fecha de vencimiento de la opción",
        optionExpireDateDescription: "Selecciona la fecha de vencimiento de la opción si aplica.",
        checkNumber: "Número de cheque",
        checkNumberDescription: "Introduce el número de cheque si aplica. Déjalo en blanco si no aplica.",
        escrowAmount: "Monto en custodia (USD)",
        escrowAmountDescription: "Introduce el monto en custodia si aplica. Este es el monto retenido en custodia para la transacción.",
        transactionFeeAmount: "Monto de la tarifa de transacción (USD)",
        transactionFeeAmountDescription: "Introduce el monto de la tarifa si aplica. Esta es la tarifa cobrada por procesar la transacción.",
        suspenseAmount: "Monto en Suspenso (USD)",
        suspenseAmountDescription: "Introduce el monto en suspenso si aplica. Se utiliza para transacciones que están retenidas temporalmente o pendientes.",
        interestAmount: "Monto de Interés (USD)",
        interestAmountDescription: "Introduce el monto de interés si aplica. Este es el interés acumulado en la transacción.",
        principalAmount: "Monto Principal (USD)",
        principalAmountDescription: "Introduce el monto principal si aplica. Es la suma original de dinero prestada o invertida, excluyendo intereses o comisiones.",
        optionStrikePrice: "Precio de Ejercicio de la Opción (USD)",
        optionStrikePriceDescription: "Introduce el precio de ejercicio de la opción si aplica. Es el precio al que la opción puede ejercerse.",
        unitQuantity: "Cantidad de Unidades",
        unitQuantityDescription: "Introduce la cantidad de unidades si aplica. Representa el número de unidades involucradas en la transacción, como artículos comprados o acciones negociadas.",
        unitPrice: "Precio por Unidad (USD)",
        unitPriceDescription: "Introduce el precio por unidad si aplica. Se utiliza en transacciones que involucran valores o inversiones.",
        transactionCategorization: "Categorización de la Transacción",
        normalizedPayeeName: "Nombre Normalizado del Beneficiario",
        normalizedPayeeNameDescription: "Introduce el nombre del beneficiario en un formato estandarizado. Esto es útil para garantizar la consistencia en los registros.",
        transactionCategory: "Categoría de la Transacción",
        transactionCategoryDescription: "Introduce la categoría de la transacción, como 'venta', 'compra' o 'transferencia'.",
        customCategory: "Categoría Personalizada",
        customCategoryDescription: "Introduce una categoría personalizada si aplica. Esto es para transacciones que no encajan en categorías predefinidas.",
        city: "Ciudad",
        cityDescription: "Introduce la ciudad relacionada con la transacción.",
        state: "Estado",
        stateDescription: "Introduce el estado o región donde ocurrió la transacción.",
        postalCode: "Código Postal",
        postalCodeDescription: "Introduce el código postal de la ubicación asociada con la transacción.",
        country: "País",
        countryDescription: "Introduce el país donde ocurrió la transacción.",
        bestRepresentation: "Mejor Representación",
        bestRepresentationDescription: "Introduce la mejor representación para la transacción, que puede ser una descripción general o clasificación.",
        runningBalanceAmountUSD: "Monto del Saldo en Curso (USD)",
        runningBalanceAmountUSDDescription: "Introduce el monto del saldo en curso en USD, que es el saldo continuo después de que la transacción se procese.",
        subaccountSecurityType: "Tipo de Seguridad de Subcuenta",
        subaccountSecurityTypeDescription: "Introduce el tipo de seguridad asociado con la subcuenta, si aplica.",
        commissionAmountUSD: "Monto de la Comisión (USD)",
        commissionAmountUSDDescription: "Introduce el monto de la comisión en USD, si aplica. Este es el cargo por la transacción.",
        tickerSymbol: "Símbolo de Cotización",
        tickerSymbolDescription: "Introduce el símbolo de cotización del activo o valor involucrado en la transacción.",
        investmentTransactionType: "Tipo de Transacción de Inversión",
        investmentTransactionTypeDescription: "Introduce el tipo de transacción de inversión, como 'compra', 'venta' o 'dividendo'.",
        taxesAmountUSD: "Monto de Impuestos (USD)",
        taxesAmountUSDDescription: "Introduce el monto de los impuestos relacionados con la transacción, en USD.",
        currencySymbol: "Símbolo de la Moneda",
        currencySymbolDescription: "Introduce el símbolo de la moneda utilizada en la transacción, como '$' para USD o '€' para EUR.",
        incomeType: "Tipo de Ingreso",
        incomeTypeDescription: "Introduce el tipo de ingreso, como 'salario', 'intereses' o 'ganancias de capital'.",
        splitDenominator: "Denominador de la División",
        splitDenominatorDescription: "Introduce el denominador para transacciones fraccionarias o divididas, si aplica.",
        splitNumerator: "Numerador de División",
        splitNumeratorDescription: "Introduce el numerador de división si aplica. Este valor se usa en transacciones que implican dividir montos en múltiples categorías o cuentas.",        
        sharesPerContract: "Acciones por Contrato",
        sharesPerContractDescription: "Introduce el número de acciones por contrato si aplica. Es relevante para transacciones de inversión o contratos que involucren acciones.",        
        subAccountFund: "Fondo de Subcuenta",
        subAccountFundDescription: "Introduce el fondo de subcuenta si aplica.",        
        securityId: "ID de Seguridad",
        securityIdDescription: "Introduce el ID de seguridad si aplica.",        
        securityIdType: "Tipo de ID de Seguridad",
        securityIdTypeDescription: "Introduce el tipo de ID de seguridad si aplica.",
        saveTransaction: "Guardar Transacción"
      },
      multiActionText: {
        selectAll: 'Seleccionar todo',
        deselectAll: 'Deseleccionar todo',
        deleteSelected: 'Eliminar seleccionados',
      },
      communicationResponse: {
        failedToLoad: 'Error al cargar',
        emailError: 'No se pudieron obtener las respuestas por correo. Inténtalo de nuevo más tarde.',
        smsError: 'No se pudieron obtener las respuestas por SMS. Inténtalo de nuevo más tarde.',
      },
      interactionHistory: {
        historyInteraction: "Historial de Interacción",
        lastContacted: "Último Contacto",
        notesLastContacted: "Nota",
        nextFollowUp: "Próximo Seguimiento",
        notesNextFollowUp: "Nota",
        preferredContactTime: "Hora de Contacto Preferida",
        preferredContactToTime: "Hasta",
        notesContactToTime: "Nota",
        noHistory: "Sin historial"
      },     
      imenuPayFlex:{
        invoiceId: "ID de Factura",
        planName: "Nombre del Plan",
        amount: "Monto",
        totalAmount: "Monto Total",
        subscription: "Suscripción",
        schedulePayment: "Calendario de Pago",
        recurringPayment: "¿Pago Recurrente?",
        frequency: "Frecuencia",
        payEvery: "Pagar cada",
        customInterval: "Intervalo Personalizado",
        customIntervalNote: "El pago se realizará cada {days} días",
        payStartsOn: "Pago inicia el",
        payUntil: "Pagar hasta",
        endsAfterDate: "El pago termina después de",
        endsAfterOccurrences: "El pago termina después de {count} ocurrencias",
        howToPay: "¿Cómo deseas pagar?",
        creditCard: "Tarjeta de Crédito",
        banking: "Transferencia Bancaria",
        placeholderCustomInterval: "2",
        placeholderOccurrences: "Ejemplo: 2",
      }, 
      googleCalendar: {
        createEvent: "Crear Evento",
        title: "Título",
        description: "Descripción",
        location: "Ubicación",
        startTime: "Hora de Inicio",
        endTime: "Hora de Finalización",
        timeZone: "Zona Horaria",
        selectTimeZone: "Seleccionar Zona Horaria",
        attendeeEmail: "Correo del Asistente",
        attendeeEmailPlaceholder: "cliente@example.com",
        attendeeEmailLabel: "Correo del Asistente",
        addAttendee: "Agregar Asistente",
        providerEmail: "Correo del Proveedor",
        providerEmailPlaceholder: "proveedor@example.com",
        color: "Color",
        selectColor: "Seleccionar un color",
        submitEvent: "Crear Evento",
        updateEvent: "Actualizar Evento",
        upcomingEvents: "Próximos eventos",
        deleteConfirmationTitle: "¿Estás seguro?",
        deleteConfirmationText: "¡No podrás revertir esto!",
        deleteNotificationCheckbox: "¿Deseas notificarles que el evento ha sido cancelado?",
        deleteConfirmButton: "Sí, eliminarlo",
        deleteCancelButton: "Cancelar",
        deleteSuccessTitle: "¡Eliminado!",
        deleteSuccessText: "El evento ha sido eliminado.",
        deleteErrorTitle: "¡Error!",
        deleteErrorText: "No se pudo eliminar el evento."
      },      
      bulkSend: {
        title: "¿Qué es el Envío Masivo?",
        text: "El Envío Masivo te permite enviar múltiples correos electrónicos y mensajes SMS a la vez, haciendo la comunicación más eficiente.",
        confirmButtonText: "¡Entendido!",
        selectRecipientsTitle: "Seleccionar Destinatarios",
        selectAllCustomers: "Seleccionar Todos los Clientes",
        selectAllSubscribers: "Seleccionar Todos los Suscriptores",
        bulkSendOptionsTitle: "Opciones de Envío Masivo",
        sendEmail: "Enviar Múltiple Correo Electrónico",
        sendSMS: "Enviar Múltiple SMS",
        whenToSend: "¿Cuándo deseas enviarlo?",
        sendNow: "Enviar Ahora",
        schedule: "Programar",
        cancel: "Cancelar",
        validationSelectMethod: "Por favor, selecciona al menos un método.",
        validationScheduledTime: "El tiempo programado debe ser en el futuro.",
        successSent: "¡Enviado con éxito!",
        successScheduled: "¡Programado con éxito!",
        error: "Ocurrió un error.",
        subject: "Notificación Masiva",
        body: "El contenido de tu mensaje programado aquí.",
        bulkSend:"Envío Masivo",
        validationSelectRecipients: "Seleccione al menos un destinatario"
      },      
      table: {
        transactionDate: 'Fecha de Transacción',
        customerId: 'ID del Cliente',
        status: 'Estado',
        debit: 'Débito',
        credit: 'Crédito',
        description: 'Descripción',
        memo: 'Nota',
        payee: 'Beneficiario',
        category: 'Categoría',
        bestRepresentation: 'Mejor Representación',
        country: 'País',
        action: 'Acción'
      }, 
      emailTest: {
        sendTest: 'Enviar Email de Prueba',
        message:
          'Este es un mensaje de ejemplo. Por favor, no responda este mensaje.',
        subject: 'Soporte de iMenuApps®.',
        success: 'El email fue enviado satisfactoriamente.'
      },
      menu: {
        titleQuoteConverted: 'Cotización convertida a Factura',
        quoteConverted: 'La cotización se ha convertido en una factura exitosamente.',
        transactionData: 'Datos de Transacción',
        bankAccountConnection: 'Conexión de Cuenta Bancaria',
        viewTransactions: 'Ver Transacciones',
        validationPhone:
          'El número de teléfono debe contener exactamente 10 dígitos.',
        restaurantAdministration: 'Admin',
        savedSuccesful: 'La configuración se cambió con éxito',
        savedFailed: 'Hubo un error en la configuración guardada.',
        lostChanges: '¡Tus cambios se perderán si sales de esta página!',
        sure: '¿Está seguro?',
        wontRevert: "No podrás revertir esto!",
        yesVoid: '¡Si, anular pago!',
        voided: '¡Anulado!',
        voidedSuccessfully: 'El pago fue anulado exitosamente.',
        yesRefund: '¡Si, reembolsar!',
        refund: '¡Reembolsado!',
        refundSuccessfully: 'El reemboldo se hizo exitosamente.',
        merchantQuoteNotes: 'Notas de cotización del comerciante',
        merchantInvoiceNotes: 'Notas de la factura del comerciante',
        titleInformationIncomplete: 'Información requerida',
        informationIncomplete:
          'Por favor completa todos los campos requeridos.',
        yes: 'Si',
        emailSend: 'Email enviado',
        emailSendTo: 'El email con la factura ha sido enviado correctamente a',
        questionSendEmail: '¿Enviar correo electrónico?',
        dialogSendEmail:
          '¿Está seguro que desea enviar el correo electrónico a',
        addNewSendEmail: 'Agregar otro correo electronico',
        send: 'Enviar',
        close: 'Cerrar',
        alertEmailSend: 'Email enviado',
        alertEmailSendTo: 'Enviado con éxito a',
        session: 'Sesión',
        foodServices: 'Productos/Servicios',
        ordersTickets: 'Órdenes/Tickets',
        reservationsDeliveries: 'Reservaciones/Entregas',
        restaurantAdministration: 'Administración',
        report: 'Reportes',
        sales: 'Ventas',
        staffOccupationsCustomersDrivers: 'Staff/Ocupaciones/Clientes/Choferes',
        marketing: 'Marketing',
        settings: 'Configuraciones',
        merchantSettings: 'Configuración del comerciante',
        revenue: 'Ingresos',
        revenueInfo:
          'La sección Ingresos en iMenuApps® es su centro centralizado para administrar todas las actividades generadoras de ingresos dentro de su negocio. Esta sección le permite manejar de manera eficiente diversas tareas relacionadas con ingresos y transacciones financieras, asegurando que sus operaciones comerciales sean fluidas y rentables. Esto es lo que puede hacer en la sección Ingresos: 1. Ver/Crear pedidos: administre los pedidos de los clientes desde su creación hasta su finalización. Esta función le permite realizar un seguimiento de todos los pedidos, garantizando que se procesen. 2. Reservas: administre y realice un seguimiento de las reservas para sus servicios, ya sea para cenas, eventos u otras reservas. Esta función garantiza que pueda gestionar eficazmente sus reservas y evitar el overbooking. 3. Cotizaciones: cree y administre cotizaciones para ingresos potenciales, lo que le permitirá brindar a los clientes información detallada sobre precios y servicios antes de finalizar una venta. Convierta fácilmente las cotizaciones aceptadas en facturas para agilizar el proceso de ingresos. 4. Facturas: genere, administre y realice un seguimiento de todas las facturas de los clientes. Esta función garantiza una facturación precisa y proporciona un registro claro de todas las transacciones de ingresos. 5. Envío: Coordine y administre los detalles de envío de los pedidos, incluida la preparación, programación y envío de los envíos. 6. Seguimiento de envíos: supervise el estado y el progreso de los envíos en tiempo real, garantizando que sus entregas se realicen según lo programado y que los clientes se mantengan informados. 7. Facturación de suscripción: administre la facturación recurrente de los servicios de suscripción, garantizando que a los clientes se les facture de manera precisa y puntual por los servicios continuos. 8. Entregas: Supervisar y gestionar todas las actividades de entrega, desde el cumplimiento del pedido hasta la entrega final a los clientes, asegurando que los bienes y servicios lleguen a su destino de manera eficiente. 9. Solicitudes de recogida: maneje las solicitudes de los clientes para la recogida de pedidos, permitiéndoles recuperar sus pedidos directamente desde la ubicación de su empresa.',
        adminInfo:
          'La sección de Administración en iMenuApps® sirve como centro de control para gestionar diversos aspectos operativos y logísticos de su negocio. A continuación se ofrece una descripción general de las funciones y tareas que puede administrar en esta sección: 1. Administración de mesas: • Configure y administre la configuración de las mesas de su negocio, incluido el número de mesas, su disposición y la capacidad de asientos. • Optimice el espacio para reservas y garantice una rotación eficiente de las mesas. 2. Gestión de impuestos: • Establezca y administre las tasas impositivas aplicables a sus artículos y servicios de selección. • Garantizar la aplicación precisa de impuestos en todas las transacciones de acuerdo con las regulaciones locales. 3. Gestión de entrega: • Supervise sus operaciones de entrega desde la asignación hasta su finalización. • Realice un seguimiento de los pedidos en tiempo real y proporcione a los clientes actualizaciones sobre sus entregas. • Garantizar servicios de entrega eficientes y oportunos para mejorar la satisfacción del cliente. 4. Gestión de personal: • Administre su equipo de personal, lo que incluye agregar nuevos miembros, actualizar roles y administrar permisos. • Establecer roles y asignar tareas para garantizar operaciones fluidas. 5. Gestión de conductores: • Administre a sus conductores de entrega, asigne tareas de entrega y realice un seguimiento de su desempeño. • Asegúrese de que su servicio de entrega funcione sin problemas y de manera eficiente. 6. Roles de permisos: • Definir y gestionar roles y permisos para el personal y los administradores. • Asegúrese de que cada miembro del equipo tenga acceso a las herramientas y la información que necesita para realizar sus tareas de manera efectiva. 7. Gestión de hojas de trabajo: • Realice un seguimiento y administre las horas y horarios de trabajo del personal. • Garantizar un control preciso del tiempo y el procesamiento de nóminas.8. Gestión de Ocupaciones: • Organiza y gestiona las diferentes ocupaciones del personal dentro de tu empresa. • Mantenga su equipo estructurado y roles bien definidos. 9. Gestión de clientes: • Gestionar la información de los clientes, realizar un seguimiento de los pedidos y mantener los perfiles de los clientes. • Mejore el servicio al cliente al tener todos los detalles del cliente fácilmente accesibles. 10. Gestión de créditos: • Maneje los créditos de los clientes de manera eficiente, aplique créditos a los pedidos y realice un seguimiento de los saldos de crédito. 11. Gestión de selecciones: • Diseñe y administre las selecciones de su empresa, incluida la creación de nuevas selecciones, la actualización de artículos y la gestión de precios. 12. Gestión de categorías: • Organice los elementos de su selección en categorías para facilitar la navegación y la gestión. • Mantenga sus selecciones estructuradas y fáciles de explorar para los clientes. 13. Gestión de productos: • Administre su inventario de productos, incluida la adición de nuevos artículos, la actualización de los existentes y la gestión de niveles de existencias. 14. Generador de códigos de barras: • Cree y administre códigos de barras para sus productos para agilizar la gestión de inventario y el seguimiento de ingresos. 15. Gestión de Servicios: • Gestiona los servicios adicionales que ofrece tu restaurante, como catering o organización de eventos. • Realice un seguimiento de las reservas de servicios y garantice un funcionamiento fluido. 16. Otros cargos: • Configure y administre cargos adicionales, como tarifas de servicio, tarifas de entrega o cargos por eventos especiales. • Garantizar que todos los cargos aplicables se reflejen con precisión en las facturas de los clientes. 17. Precios Especiales: • Administrar y aplicar precios especiales para promociones, descuentos o programas de fidelización. • Ofrecer precios competitivos para atraer y retener clientes. 18. Gestión de suscriptores: • Administre su lista de suscriptores de clientes para boletines y promociones. 19. eMarketing: • Planificar y ejecutar campañas de marketing por correo electrónico y SMS. • Utilice los datos de los clientes para dirigirse a audiencias específicas y atraer más negocios a su restaurante. Esta sección le brinda todas las herramientas que necesita para administrar eficientemente las operaciones de su empresa, desde el personal y los clientes hasta las selecciones y el marketing, todo en un solo lugar.',
        imenuBookInfo:
          'La sección iMenuBooks es su centro integral de gestión financiera y contabilidad. Esta área le permite administrar transacciones sin problemas, conectarse con cuentas bancarias y mantener un registro claro y preciso de sus actividades financieras. Esto es lo que puede hacer en la sección iMenuBooks: 1. Datos de transacciones: administre y almacene todos los datos de transacciones relacionados con su negocio. Esta función le permite realizar un seguimiento de cada transacción financiera, garantizando que sus registros sean precisos y estén actualizados. 2. Conexión de cuenta bancaria: conecte las cuentas bancarias de su empresa directamente al sistema iMenuBooks. Esta función permite la sincronización automática de datos financieros, lo que facilita la gestión de ingresos, gastos y saldos de cuentas. 3. Ver transacciones: vea registros detallados de todas las transacciones financieras procesadas a través de su empresa. Esta función proporciona una vista organizada y con capacidad de búsqueda de su historial de transacciones, lo que le permite monitorear y auditar las actividades financieras con facilidad.',
        reportsInfo:
          'La sección Informes es su centro centralizado para acceder y analizar el rendimiento y los datos financieros de su empresa. Esta sección le proporciona varias herramientas e informes para ayudarle a tomar decisiones informadas basadas en datos en tiempo real. Esto es lo que puede hacer en la sección Informes: 1. Pagos: realice un seguimiento y revise todos los pagos realizados por los clientes. Esta función proporciona un desglose detallado de las transacciones de pago, lo que le ayuda a controlar los ingresos y garantizar registros financieros precisos. 2. Cuenta interna: administre y revise las cuentas internas utilizadas por sus clientes habituales. Esta función le permite realizar un seguimiento de los saldos, cargos y pagos de las cuentas, garantizando que sus cuentas internas estén siempre actualizadas. 3. Ingresos por clientes: analice los datos de ingresos segmentados por clientes individuales. Este informe le ayuda a identificar clientes clave y comprender sus comportamientos de compra, lo que permite realizar marketing dirigido y mejorar las relaciones con los clientes. 4. Ingresos por productos: vea datos de ingresos basados ​​en productos específicos. Este informe le permite identificar los artículos más vendidos y comprender el rendimiento del producto, lo que le ayuda en la gestión del inventario y en las decisiones de desarrollo de productos. 5. Informe dinámico: genere informes personalizados adaptados a sus necesidades comerciales específicas. Esta característica le permite crear informes dinámicos seleccionando varios parámetros, lo que le brinda la flexibilidad de analizar sus datos desde múltiples perspectivas.',
        configInfo:
          "La sección Configuración del comerciante le permite configurar varios aspectos esenciales de sus operaciones comerciales, asegurando que la plataforma se alinee con sus requisitos y preferencias únicos.  Esta sección incluye las siguientes áreas clave: 1. Configuración general: • Información comercial: configure y actualice la presencia en línea de su empresa, incluido el nombre, la dirección, los detalles de contacto, los enlaces de redes sociales y la moneda del restaurante. • Presencia en línea: administre la URL, la ubicación y los detalles del fax de su sitio web. Esto es crucial para garantizar que los clientes puedan encontrarlo y comunicarse con usted fácilmente. • Horario comercial: establezca y actualice su horario de atención para garantizar que sus clientes sepan cuándo está disponible. • Términos y políticas: edite y administre fácilmente sus Términos de uso, Política de privacidad y otras políticas relevantes para garantizar el cumplimiento y la transparencia con sus clientes. • Configuración de catering y entrega: defina estados de catering, códigos postales aplicables y tipos de eventos de catering. Además, administre zonas de entrega y alterne funciones como cargos de entrega, visualización de geolocalización y visibilidad de calificaciones. • Comercio electrónico y ventas en línea: controle funciones como facturas con cargos por pagos atrasados, solicitudes de recogida de activos y depósitos, lo que garantiza transacciones en línea y gestión de pedidos sin inconvenientes. 2. Funcionalidades: configure funcionalidades específicas para pedidos y reservas de catering, incluidas preferencias de ubicación de mesas, vistas de reservas de clientes, opciones de pago anticipado y configuraciones basadas en tiempo. • Configuración de facturas y cotizaciones: configure números iniciales y prefijos para sus facturas y cotizaciones, lo que le ayudará a mantener un sistema de facturación organizado y profesional. • Gestión de pedidos: configure y administre prefijos de pedidos, horarios de recogida y otras configuraciones relacionadas con los pedidos para agilizar el procesamiento de sus pedidos. • Configuración de propinas: administre los requisitos de propinas, incluida la configuración de porcentajes de propinas predeterminados, lo cual es particularmente útil para las industrias de servicios. • Configuración de visibilidad: controle si cierta información o funciones son visibles para sus clientes, como por ejemplo si se muestra al cocinero u otros negocios. 3. Configuración de diseño: • Esquema de colores: personalice el esquema de colores de su aplicación, incluidos los colores primarios, secundarios y terciarios, para alinearlos con su identidad de marca. Adapte los aspectos visuales de su plataforma ajustando los colores primarios, secundarios y terciarios, personalizando la señalización digital y administrando diapositivas sobre nosotros para presentar su negocio de manera atractiva. • Diapositivas Acerca de nosotros: administre las diapositivas que aparecen en la sección 'Acerca de nosotros', lo que le permitirá mostrar las ofertas y la personalidad únicas de su empresa. • Señalización digital: configure la señalización digital para mostrar información clave, selecciones y anuncios dentro de su aplicación o en su ubicación física. 4. Copia de seguridad y administración de dispositivos: • Administración de dispositivos: agregue y administre dispositivos conectados a su sistema, como sistemas POS, impresoras y más, asegurando que todo esté sincronizado y funcionando correctamente. • Opciones de copia de seguridad: cree copias de seguridad de sus datos y configuraciones para garantizar que tenga un sistema de seguridad en caso de cualquier problema técnico. Puede descargar copias de seguridad, restaurar desde el portal o restaurar desde un archivo. Garantice la seguridad de los datos realizando copias de seguridad, restaurando desde archivos y administrando dispositivos conectados, como terminales de pago. Estas configuraciones le permiten adaptar su experiencia iMenuApps® a las necesidades de su negocio, lo que facilita la gestión de las operaciones y mantiene una presencia de marca constante en todos los puntos de contacto con el cliente.",
        selections: 'Selecciones',
        productManagement: 'Gestión de Productos'
      },
      controlPanel: {
        googleCalendar: 'Calendario de Google',
        notificationCenter: 'Centro de notificaciones',
        notificationBell: 'Campana de notificaciones',
        salesByCustomers: 'Ventas por clientes',
        salesByProducts: 'Ventas por productos',
        dynamicReport: 'Informe dinámico',
        events: "Crear Eventos",
        eventTitle: "Eventos",
        transactionData: 'Agrega y edita transacciones financieras',
        bankConnect: 'Agrega tus cuentas de banco y tarjetas de credito',
        viewTransaction: 'Ver / Editar / Agregar tus transactions',
        subscription:
          'Ver y Crear Suscripciones y Facturación (Terminal Virtual)',
        staff:
          'Creación de cuentas de usuario de los trabajadores del negocio.',
        occupations:
          'Gestión de las ocupaciones del negocio. Las ocupaciones están relacionadas con los miembros del staff. Cada miembro tiene una ocupación específica.',
        roles:
          'Gestión de roles. Los roles establecen los permisos sobre las diferentes áreas de la aplicación y están relacionados con los miembros del staff. Un miembro del staff puede tener varios roles.',
        workSheet:
          'Gestión de hojas de trabajo. Las hojas de trabajo permiten llevar un control sobre el horario de los trabajadores.',
        customers: 'Muestra un listado de los clientes del negocio.',
        categories:
          'Gestiona las distintas categorías de los menús. Las categorías están relacionadas con los elementos del menú. Un elemento de menú pertenece a una categoría.',
        menuItems:
          'Gestión de los elementos del menú. Un menú está compuesto por categorías, y a su vez, los elementos del menú se relacionan con el menú a través de las categoría a la que pertenece.',
        services:
          'Gestión de los servicios. Los servicios se usan en los menús de catering.',
        menus:
          'Gestión de los menús. Permite la gestión de menús. Un menú está compuesto por diversas categorías.',
        orders: 'Ver y crear órdenes.',
        invoices: 'Ver y Crear Facturas.',
        quotes: 'Ver y Crear Propuestas.',
        cateringOrders: 'Permite la visualización de órdenes de catering.',
        orderForDelivery:
          'Muestra un listado de las órdenes que están listas para ser entregadas al chofer que le ha sido asignado la orden.',
        tickets:
          'Permite la creación y el seguimiento de tickets. Los tickets son órdenes que se mantienen abiertas mientra el cliente siga consumiendo.',
        otherCharges:
          'Permite la gestion de cargos adiciones por cantidad de productos.',
        taxes: 'Gestión de impuestos.',
        deliveries: 'Gestión de los precios de entrega.',
        reservations: 'Gestionar y crear reservas y listas de espera',
        tables: 'Gestión de las capacidades del negocio.',
        payments: 'Muestra el listado de las transacciones de pago realizadas.',
        aboutSettings:
          'Permite la gestión del slider que aparece en la página de inicio de cada negocio.',
        paymentSettings:
          'Permite la configuración de la pasarela de pago que se utilizará para procesar las transacciones.',
        basicSettings:
          'Permite la configuración de los datos principales del negocio: Nombre, Dirección, Teléfono. Esta información aparece en la página principal de cada negocio.',
        funtionalitiesSettings:
          'Permite la configuración del funcionamiento general del negocio: Horarios, Zip codes, propinas...',
        colorSettings:
          'Permite la configuración de los colores de la aplicación.',
        systemSettings:
          'Permite la configuración de la integración de iMenuApps® con aplicaciones de terceros.',
        driver: 'Administrar choferes externos.',
        credit: 'Permite la administración de créditos.'
      },
      options: {
        sameAsBilling: 'Igual que la dirección de',
        contactPerson: 'Persona de contacto',
        email: 'Correo electrónico',
        aditionalDetails: 'Detalles adicionales',
        street: 'Calle',
        text: 'Hubo un problema al establecer la dirección predeterminada.',
        updateAddress: 'Dirección actualizada',
        wrongAddress: 'Algo salió mal al intentar actualizar la dirección predeterminada',
        billingAddress: 'Direccion de la facturación',
        shippingAddress: 'Direccion de envío',
        placeholderNotes: 'Escribe tus notas aquí',
        dataRequired: 'Dato Requerido',
        customerArea: 'Area del cliente',
        customerName: 'Nombre del cliente',
        customerEmail: 'Email del cliente',
        customerPhone: 'Teléfono del cliente',
        customerAddress: 'Dirección del cliente',
        terms: 'Términos',
        trackingN: 'Número de rastreo',
        shippingDate: 'Fecha de envío',
        shippingTo: 'Enviar hacia',
        footer: 'Edite el pie de página respectivo para su módulo de ingresos',
        ivoiceDate: 'Fecha de factura',
        quoteDate: 'Fecha de cotización',
        subscriptionBilling: 'Facturación de suscripción',
        driverDeliveries: 'Entregas',
        activeDriverOrder: 'Órdenes activas',
        completedDriverOrder: 'Pedidos completados',
        useDirection: 'Click si es la misma direccion del cliente',
        menuTitle: 'ADMINISTRACIÓN',
        login: 'Iniciar Sesión',
        logout: 'Cerrar Sesión',
        controlPanel: 'Panel de Control',
        adminSettings: 'Configuración de administrador',
        supportPanel: 'Soporte',
        manageMenus: 'Menús',
        managePyments: 'Pagos',
        manageHouseAccount: 'Cuenta Casa',
        viewOrders: 'Ver/Crear Órdenes',
        viewQuotes: 'Propuestas',
        viewInvoice: 'Facturas',
        manageCategories: 'Categorías',
        manageProducts: 'Item',
        manageServices: 'Servicios',
        manageCustomers: 'Clientes',
        manageCredits: 'Créditos',
        manageTables: 'Mesas',
        manageTaxes: 'Impuestos',
        manageShippings: 'Envíos',
        manageOtherCharges: 'Otros Recargos',
        manageUsers: 'Equipo de trabajo',
        manageDriver: 'Choferes',
        manageRoles: 'Roles/Permisos',
        manageWorkSheet: 'Hoja de Trabajo',
        manageBasicSettings: 'Negocio',
        manageRestaurantSettings: 'Configuración de Negocio',
        manageAboutSettings: 'Acerca De Slides',
        manageFunSettings: 'Funcionamiento',
        manageColourSettings: 'Colores',
        manageDesign: 'Diseño',
        manageMore: 'Más',
        managePaymentSettings: 'Pagos',
        manageOccupation: 'Puestos',
        manageKeySettings: 'Sistemas Externos',
        supportSettings: 'Configuraciones de Soporte',
        changeServerId: 'Cambiar Employee ID',
        serverId: 'Clave de empleado',
        manageVariantGroup: 'Opciones',
        manageReservation: 'Reservaciones',
        manageWaitList: 'Lista de Espera',
        viewCateringOrders: 'Órdenes de Catering',
        forgotPassword: 'Olvidó su contraseña?',
        sendNewPassword: 'Enviar un nuevo password',
        serverIdMessage:
          'Este es el código de seguridad que se le asignó cuando se creó su perfil.',
        recoveryPassword: 'Recuperar contraseña',
        refund: 'Refund',
        void: 'Void'
      },
      titles: {
        technology: "Tecnología",
        retail: "Comercio",
        healthcare: "Atención médica",
        finance: "Finanzas",
        retailGeneralMerchandise: "Comercio (Mercancías Generales)",
        healthcareServices: "Servicios de atención médica",
        foodAndBeverage: "Alimentos y Bebidas (Restaurantes, Cafés, Bares)",
        construction: "Construcción",
        eCommerce: "Comercio electrónico",
        informationTechnology: "Tecnologías de la Información (Servicios de TI y Desarrollo de Software)",
        realEstate: "Bienes Raíces (Residencial y Comercial)",
        transportationLogistics: "Transporte y Logística",
        professionalServices: "Servicios Profesionales (Consultoría, Legal, Contabilidad)",
        manufacturing: "Manufactura (General y Especializada)",
        educationTraining: "Educación y Servicios de Capacitación",
        entertainmentMedia: "Entretenimiento y Medios",
        financialServices: "Servicios Financieros (Bancos, Firmas de Inversión)",
        personalCareServices: "Servicios de Cuidado Personal (Salones, Spas)",
        hospitality: "Hospitalidad (Hoteles, Agencias de Viajes)",
        insuranceAgencies: "Agencias de Seguros",
        homeImprovementRepair: "Mejoras y Reparaciones del Hogar",
        automotiveServices: "Servicios Automotrices (Reparación, Concesionarios, Talleres)",
        telecommunications: "Telecomunicaciones",
        nonprofitSocialServices: "Servicios Sociales y Organizaciones sin Fines de Lucro",
        agricultureFarming: "Agricultura y Ganadería",
        pharmaceuticalsBiotechnology: "Farmacéutica y Biotecnología",
        energy: "Energía (Renovable y No Renovable)",
        sportsRecreation: "Deportes y Recreación",
        fitnessWellness: "Bienestar y Fitness",
        marketingAdvertising: "Marketing y Publicidad",
        eventPlanning: "Planificación de Eventos y Servicios",
        cleaningServices: "Servicios de Limpieza (Residenciales y Comerciales)",
        fashionApparel: "Moda y Ropa",
        foodProductionProcessing: "Producción y Procesamiento de Alimentos",
        petServices: "Servicios para Mascotas (Aseo, Hospedaje, Veterinaria)",
        artsCrafts: "Artes y Manualidades (Servicios Creativos)",
        aerospaceDefense: "Aeroespacial y Defensa",
        environmentalServices: "Servicios Ambientales",
        technologyHardwareElectronics: "Hardware y Electrónica Tecnológica",
        childcareServices: "Servicios de Cuidado Infantil",
        securityServices: "Servicios de Seguridad (Ciberseguridad, Seguridad Física)",
        publishing: "Publicación (Libros, Revistas, Medios Digitales)",
        transportationEquipmentManufacturing: "Fabricación de Equipos de Transporte",
        architectureDesign: "Arquitectura y Diseño",
        accountingTaxPreparation: "Contabilidad y Preparación de Impuestos",
        landscapingGardening: "Jardinería y Paisajismo",
        beverageProduction: "Producción de Bebidas (Cerveza Artesanal, Vino, Licores)",
        medicalDevicesSupplies: "Dispositivos y Suministros Médicos",
        warehousingStorage: "Almacenamiento y Bodega",
        freelancing: "Trabajo Freelance (Escritura, Diseño Gráfico, Programación)",
        tourismAdventureServices: "Servicios de Turismo y Aventura",
        utilitiesPublicServices: "Servicios Públicos y de Utilidades",
        blockchainCryptocurrency: "Blockchain y Criptomonedas",
        specializedRetail: "Retail Especializado (Productos y Servicios de Nicho)",
        eventPlanningServices: "Planificación de Eventos y Servicios",
        transportationEquipment: "Fabricación de Equipos de Transporte",
        accountingTax: "Contabilidad y Preparación de Impuestos",
        tourismAdventure: "Servicios de Turismo y Aventura",
        shareViaEmailAndSMS: 'Compartir por correo electrónico y SMS',
        sendEmail: 'Enviar correo electrónico',
        sendSMS: 'Enviar SMS',
        send: "Enviar",
        sendNow: 'Enviar ahora',
        schedule: 'Programar',
        cancel: 'Cancelar',
        selectMethod: 'Por favor, seleccione al menos un método (Correo electrónico o SMS)',
        emailCheck: 'Por favor, ingrese un correo electrónico o desmarque la opción de Correo electrónico.',
        smsCheck: 'Por favor, ingrese un número de teléfono o desmarque la opción de SMS.',
        searchCustomer: 'Buscar cliente o suscriptor',
        emailPlaceholder: 'Correo electrónico',
        phonePlaceholder: 'Teléfono',
        sendByEmailAndSMS: 'Enviar por correo electrónico y SMS',
        textSend: 'Puede agregar varias direcciones de correo electrónico agregando una coma después de cada uno',
        sendNotification: 'Estás a punto de enviar esta notificación a:',
        whenToSend: '¿Cuándo quieres enviarlo?',
        bankAccountName: 'Nombre de la cuenta de banco',
        routeNumber: 'Número de ruta',
        accountNumber: 'Número de cuenta',
        bankAccountAddress: 'Dirección de la cuenta de banco',
        nameAuthorizedPerson: 'Nombre de la persona autorizada',
        paymentAmount: 'Monto del pago',
        warning: 'Advertencia',
        messageChangeQuote:
          'Si cambia este prefijo nuevamente, la numeración de secuencia de sus Cotizaciones cambiará',
        messageChangeIvoice:
          'Si cambia este prefijo nuevamente, la numeración de secuencia de sus Facturas cambiará',
        messageStartingInvoiceNumber:
          'Si cambia este número inicial, la numeración de sus facturas se restablecerá para comenzar desde este número.',
        prefixQuotes: 'Prefijo para Cotizaciones (por ejemplo, QTE)',
        prefixInvoices: 'Prefijo para facturas (por ejemplo, INV)',
        invoiceStartingNumber: 'Número inicial de factura',
        moneyNotEnought: 'Cantidad debe ser mayor al total para cambio',
        mustBe: 'Debe tener 9 dígitos',
        controlPanel: 'Panel de Control',
        supportPanel: 'Soporte',
        menus: 'Menús',
        orders: 'Órdenes',
        quotes: 'Propuestas',
        invoices: 'Facturas',
        allOrders: 'Todas las Órdenes',
        customerCredit: 'Créditos de Clientes',
        workSheet: 'Hoja de Trabajo',
        cateringOrders: 'Órdenes de Catering',
        ordersForDelivery: 'Órdenes Para Entregar',
        suscriptors: 'Suscriptores',
        tickets: 'Órdenes de Tickets',
        categories: 'Categorías',
        products: 'Elementos de menú',
        services: 'Servicios',
        customers: 'Clientes',
        tables: 'Mesas',
        taxes: 'Impuestos',
        shippings: 'Precios de Envío',
        otherCharges: 'Otros Cargos',
        newsletter: 'Boletín',
        users: 'Equipo de Trabajo',
        suscriptor: 'Suscriptores',
        createCustomer:"Crear Cliente",
        communicationResponse: 'Respuesta de comunicación',
        smsResposes: "Respuestas SMS",
        emailResponses: "Respuestas Email",
        loadingEmailResponses: "Cargando Respuestas de SMS...",
        loadingSmsResponses: "Cargando Respuestas de Email...",
        perPage: "Por Página",
        emailNoSent: "Email no enviado",
        noEmailResponses: "Sin Respuestas de Email",
        noEmailFound: "No se encontraron respuestas de email en tu cuenta",
        noSmsResponses: "Sin Respuestas de SMS",
        noSmsFound: "No se encontraron respuestas de SMS en tu cuenta",
        createSubscriptor: "Crear Suscriptor",
        occupation: 'Puestos de Trabajo',
        roles: 'Roles',
        about: 'Acerca de',
        digitalScreens: 'Pantallas Digitales',
        editAboutForm: 'Editar Información de Acerca de',
        newAboutForm: 'Crear Información de Acerca de',
        editDisplayForm: 'Editar diapositiva de señalización digital',
        newDisplayForm: 'Crear diapositiva de señalización digital',
        basicConfig: 'Conf. Básica',
        functions: 'Funcionamiento',
        colors: 'Colores',
        variantGroup: 'Opciones',
        loading: 'Por favor, un momento...',
        editColorSetting: 'Editar  Colores',
        createColorSetting: 'Crear  Colores',
        orderCateringForm: 'Editar Orden de Catering',
        deliveryLocation: 'Ubicación de la entrega',
        cateringMenus: 'Menus de catering',
        payments: 'Pagos',
        ticketDetails: 'Detalles del Ticket',
        emptyResult: 'Sin resultados',
        cancellationType: 'Tipo de cancelación',
        changePassword: 'Cambiar contraseña',
        restaurantName: 'Nombre del negocio',
        clockinClockout: 'Hora de entrada - Hora de salida',
        clockin: 'Hora de entrada',
        clockout: 'Hora de salida',
        timecard: 'Asistencia',
        timesheet: 'Asistencia del día',
        staff: 'Personal'
      },
      orderState: {
        started: 'iniciada',
        inKitchen: 'en cocina',
        cooked: 'cocinada',
        pending: 'pendiente de entrega',
        delivery: 'entregada'
      },
      list: {
        buttons: {
          goToControlPanel: 'Volver a la administración'
        },
        actions: {
          addANew: 'Añadir',
          edit: 'Editar',
          delete: 'Eliminar',
          view: 'Ver'
        },
        entitiesName: {
          menu: 'menú',
          category: 'categoría',
          categoryPlaceholder: 'Seleccione categoría',
          product: 'elemento de menú',
          customer: 'cliente',
          table: 'mesa',
          tax: 'impuesto',
          taxPlaceholder: 'Seleccione impuesto',
          shipping: 'envío',
          otherCharge: 'otros cargos',
          user: 'usuario',
          order: 'órdenes',
          role: 'rol',
          about: 'acerca de'
        },
        messages: {
          confirmDelete: 'Confirmar eliminación',
          confirmAccept: 'Confirmar item',
          confirmProduct: 'Confirma la inclusión de este item?',
          deleteCategory: 'Quiere eliminar esta categoría?',
          deleteRestaurant: 'Quiere eliminar este negocio?',
          deleteOrder: 'Quiere eliminar esta order?',
          deleteCredit: 'Quiere eliminar este crédito?',
          deleteWorkSheet: 'Quiere eliminar esta hoja de trabajo?',
          deleteCustomer: 'Quiere eliminar este cliente?',
          deleteMenu: 'Quiere eliminar este menú?',
          deleteOtherCharge: 'Quiere eliminar este cargo?',
          deleteNewsletter: 'Quiere eliminar este boletín?',
          deleteProduct: 'Quiere eliminar este elemento de menú?',
          deleteShipping: 'Quiere eliminar este envío?',
          deleteTable: 'Quiere eliminar esta mesa?',
          deleteTax: 'Quiere eliminar este impuesto?',
          deleteUser: 'Quiere eliminar este usuario?',
          deleteSuscriptor: 'Quiere eliminar este suscriptor?',
          deleteRole: 'Quiere eliminar este rol?',
          deleteAbout: 'Quiere eliminar esta información?',
          deleteDisplay: '¿Quiere eliminar este anuncio?',
          deleteOccupation: 'Quiere eliminar este puesto?',
          deleteVariantGroup:
            'Quiere eliminar esta opción de elemento de menú?',
          infoDeleteSuccess: 'Información',
          invalidCode: 'Código no válido, inténtalo de nuevo.',
          messageDeleteSuccessCategory:
            'La categoría fue eliminada satisfactoriamente',
          messageDeleteSuccessRestaurant:
            'El negocio fue eliminado satisfactoriamente',
          messageDeleteSuccessOrder:
            'La orden fue eliminada satisfactoriamente',
          messageDeleteSuccessCredit:
            'El crédito fue eliminado satisfactoriamente',
          messageDeleteSuccessWorkSheet:
            'La hoja de trabajo fue eliminada satisfactoriamente',
          messageDeleteSuccessCustomer:
            'El cliente fue eliminado satisfactoriamente',
          messageDeleteSuccessMenu: 'El menú fue eliminado satisfactoriamente',
          messageDeleteSuccessOtherCharges:
            'El cargo fue eliminado satisfactoriamente',
          messageDeleteSuccessNewsletter:
            'El boletín fue eliminado satisfactoriamente',
          messageDeleteSuccessProduct:
            'El elemento de menú fue eliminado satisfactoriamente',
          messageDeleteSuccessShipping:
            'El envío fue eliminado satisfactoriamente',
          messageDeleteSuccessTable: 'La mesa fue eliminada satisfactoriamente',
          messageDeleteSuccessTax:
            'El impuesto fue eliminado satisfactoriamente',
          messageDeleteSuccessUser:
            'El usuario fue eliminado satisfactoriamente',
          messageDeleteSuccessSuscriptor:
            'El suscriptor fue eliminado satisfactoriamente',
          messageActivareSuccessSuscriptor:
            'El suscriptor fue activado satisfactoriamente',
          messageDesactivareSuccessSuscriptor:
            'El suscriptor fue desactivado satisfactoriamente',
          messageDeleteSuccessRole: 'El rol fue eliminado satisfactoriamente',
          messageDeleteSuccessAbout:
            'La información fue eliminada satisfactoriamente',
          messageDeleteSuccessOccupation:
            'El puesto fue eliminado satisfactoriamente',
          messageDeleteSuccessVariantGroup:
            'La opción fue eliminada satisfactoriamente',
          messageCateringApproved:
            'La orden de catering ha sido aprovada satisfactoriamente',
          messageCateringCancelled:
            'La orden de catering fue cancelada satisfactoriamente',
          titleEditCategory: 'Editar categoría',
          titleEditCustomer: 'Editar cliente',
          titleEditMenu: 'Editar menú',
          titleEditOtherCharges: 'Editar cargo',
          titleEditProduct: 'Editar elemento de menú',
          titleEditShipping: 'Editar envío',
          titleEditTable: 'Editar mesa',
          titleEditTax: 'Editar impuesto',
          titleEditUser: 'Editar usuario',
          titleEditRole: 'Editar rol',
          titleEditSetting: 'Editar configuración',
          titleEditOccupation: 'Editar puesto',
          titleCreateCategory: 'Crear categoría',
          titleCreateCustomer: 'Crear cliente',
          titleCreateMenu: 'Crear menú',
          titleCreateOtherCharges: 'Crear cargo',
          titleCreateProduct: 'Crear elemento ',
          titleCreateShipping: 'Crear envío',
          titleCreateTable: 'Crear mesa',
          titleCreateTax: 'Crear impuesto',
          titleCreateUser: 'Crear usuario',
          titleCreateRole: 'Crear rol',
          titleCreateSetting: 'Crear configuración',
          titleCreateOccupation: 'Crear puesto',
          titleEditVariantGroup: 'Editar opción',
          titleCreateVariantGroup: 'Crear opción',
          messageEditSuccessCategory:
            'La categoría fue editada satisfactoriamente',
          messageEditSuccessCredit: 'El crédito fue editado satisfactoriamente',
          messageEditSuccessCustomer:
            'El cliente fue editado satisfactoriamente',
          messageEditSuccessMenu: 'El menú fue editado satisfactoriamente',
          messageEditSuccessWorksheet:
            'La hoja de trabajo fue editada satisfactoriamente',
          messageEditSuccessOtherCharges:
            'El cargo fue editado satisfactoriamente',
          messageEditSuccessProduct:
            'El elemento de menú fue editado satisfactoriamente',
          messageEditSuccessShipping: 'El envío fue editado satisfactoriamente',
          messageEditSuccessTable: 'La mesa fue editada satisfactoriamente',
          messageEditSuccessTax: 'El impuesto fue editado satisfactoriamente',
          messageEditSuccessUser: 'El usuario fue editado satisfactoriamente',

          messageEditSuccessSuscriptor:
            'El suscriptor fue editado satisfactoriamente',
          messageEditSuccesRole: 'El rol fue editado satisfactoriamente',
          messageEditSuccessSetting:
            'Las configuraciones fueron editadas satisfactoriamente',
          messageEditSuccessOccupation:
            'El puesto fue editado satisfactoriamente',
          messageEditSuccessVariantGroup:
            'La opción fue editada satisfactoriamente',
          messageDeleteSuccessVariant:
            'La opción fue eliminada satisfactoriamente',
          messageEditSuccessVariant: 'La opción fue editada satisfactoriamente',
          messageCreateSuccessVariant:
            'La opción fue creada satisfactoriamente',
          messageCreateSuccessCategory:
            'La categoría fue creada satisfactoriamente',
          messageCreateSuccessCredit:
            'El crédito fue creado satisfactoriamente',
          messageCreateSuccessCustomer:
            'El cliente fue creado satisfactoriamente',
          messageCreateSuccessMenu: 'El menú fue creado satisfactoriamente',
          messageCreateSuccessWorksheet:
            'La hoja de trabajo fue creada satisfactoriamente',
          messageCreateSuccessOtherCharges:
            'El cargo fue creado satisfactoriamente',
          messageCreateSuccessProduct:
            'El elemento de menú fue creado satisfactoriamente',
          messageCreateSuccessShipping:
            'El envío fue creado satisfactoriamente',
          messageCreateSuccessTable: 'La mesa fue creada satisfactoriamente',
          messageCreateSuccessTax: 'El impuesto fue creado satisfactoriamente',
          messageCreateSuccessUser: 'El usuario fue creado satisfactoriamente',

          messageCreateSuccessSuscriptor:
            'El suscriptor fue creado satisfactoriamente',
          messageCreateSuccessRole: 'El rol fue creado satisfactoriamente',
          messageCreateSuccessSetting:
            'La configuración fue creada satisfactoriamente',
          messageCreateSuccessOccupation:
            'El puesto fue creado satisfactoriamente',
          messageCreateSuccessVariantGroup:
            'La opción fue creada satisfactoriamente',
          menuChangeState: 'El estado del menú se cambió satisfactoriamente',
          activeMenu: 'Activar menú',
          otherChargeChangeState:
            'El estado del cargo se cambió satisfactoriamente',
          activeOtherCharge: 'Activar cargo',
          taxChangeState: 'El estado del impuesto se cambió satisfactoriamente',
          activeTax: 'Activar impuesto',
          shippingChangeState:
            'El estado del envío se cambió satisfactoriamente',
          activeShipping: 'Activar envío',
          deleteSubtitleCategory: 'Eliminar categoría',
          deleteSubtitleCustomer: 'Eliminar cliente',
          deleteSubtitleMenu: 'Eliminar menú',
          deleteSubtitleOtherCharge: 'Eliminar cargo',
          deleteSubtitleProduct: 'Eliminar elemento de menú',
          deleteSubtitleShipping: 'Eliminar envío',
          deleteSubtitleTable: 'Eliminar mesa',
          deleteSubtitleTax: 'Eliminar impuesto',
          deleteSubtitleUser: 'Eliminar usuario',
          deleteSubtitleRole: 'Eliminar rol',
          deleteSubtitleAbout: 'Eliminar información',
          deleteSubtitleOccupation: 'Eliminar puesto',
          deleteSubtitleVariantGroup: 'Eliminar opción',
          errorTitle: 'Error',
          errorMessage: 'Lo sentimos, ocurrió un error de conexión.',
          changeOrderStateMessage: 'Cambiar estado de la orden',
          changeOrderStateSuccess:
            'El estado de la orden fue cambiado satisfactoriamente',
          changeOrderStateCanceled: 'La orden fue cancelada',
          connectionError: 'Error de conexión',
          sharedWorksheet: 'Hoja de trabajo compartida con el Staff',
          connectionErrorMessage:
            'Hubo un error de conexión. Por favor, verifique su conexión a internet y vuelva a intentarlo. Si el problema persiste, contacte a su proveedor de servicios.',
          newPasswordSent: 'La contraseña nueva fue enviada a su email.',
          emailOrPasswordIncorrect: 'El email o la contraseña es incorrecta',
          buttons: {
            cancel: 'Cancelar',
            delete: 'Eliminar',
            close: 'Cerrar',
            goToAdministration: 'Administración',
            goToList: 'Ir al listado',
            retry: 'Reintentar'
          }
        }
      },
      form: {
        includeMiddleName: 'Incluir nombre de en medio y apellido',
        login: 'Iniciar sesión',
        events: {
          backgroundImage: 'Imagen de fondo',
          backgroundColor: 'Color de fondo',
          backgroundColorSection: 'Agregar color de fondo a esta sección',
          backgroundColorDates: 'Color de fondo para fechas',
          backgroundColorTitle: 'Color de fondo del título',
          backgroundColorSubtitle: 'Color de fondo del subtítulo',
          backgroundColorDescription: 'Color de fondo de la descripción',
          backgroundColorFooter: 'Color de fondo del pie de página',
          startDate: 'Fecha de inicio',
          endDate: 'Fecha de finalización',
          startTime: 'Hora de inicio',
          endTime: 'Hora de finalización',
          dates: 'Fechas',
          title: 'Título',
          subtitle: 'Subtítulo',
          description: 'Descripción',
          footer: 'Pie de página',
          saveToCalendar: 'Agregar a Google Calendar'
        },
        colour: {
          primaryColor: 'Color primario',
          primary: 'Primario',
          primaryText: 'Texto primario',
          secondaryColor: 'Color secundario',
          secondary: 'Secundario',
          secondaryText: 'Texto secundario',
          tertiaryColor: 'Color terciario',
          tertiary: 'Terciario',
          tertiaryText: 'Texto terciario',
          successColor: 'Color success',
          success: 'Success',
          successText: 'Texto success',
          dangerColor: 'Color danger',
          danger: 'Danger',
          dangerText: 'Texto danger',
          backgroundColorFooter: 'Color de fondo del pie de página',
          background: 'Fondo'
        },
        tableShape: {
          square: 'Cuadrada',
          rectangular: 'Rectangular',
          circle: 'Circular',
          oval: 'Ovalada'
        },
        buttons: {
          backToCategoriesList: 'Regresar al listado de categorías',
          backToCustomersList: 'Regresar al listado de clientes',
          backToMenusList: 'Regresar al listado de menús',
          backToOrdersList: 'Regresar al listado de órdenes',
          backToOtherChargesList: 'Regresar al listado de otros cargos',
          backToProductsList: 'Regresar al listado de elementos de menú',
          backToShippingsList: 'Regresar al listado de envíos',
          backToTablesList: 'Regresar al listado de mesas',
          backToTaxesList: 'Regresar al listado de impuestos',
          backToUsersList: 'Regresar al listado de usuarios',
          backToRolesList: 'Regresar al listado de roles',
          backToAboutList: 'Regresar al listado de acerca de',
          backToMenu: 'Regresar al menú',
          cancelOrder: 'Cancelar orden',
          changeState: 'Cambiar estado a',
          defaultColor: 'Restablecer',
          addChoice: 'Añadir Variante',
          back: 'Atrás',
          save: 'Guardar',
          submit: 'Someter',
          change: 'Cambiar',
          add: 'Añadir'
        },
        titles: {
          identificationInformation: "Información de Identificación",
          idType: "Tipo de ID",
          driverLicense: "Licencia de Conducir",
          internationalId: "ID Internacional (Cédula)",
          nameLicense: "Nombre en la Licencia",
          licenseNumber: "Número de Licencia",
          issueDate: "Fecha de Emisión",
          expirationDate: "Fecha de Expiración",
          sex: "Sexo",
          dateBirth: "Fecha de Nacimiento",
          meters: "Metros",
          feet: "Pies",
          centimeters: "Centimetros",
          inches: "Pulgadas",
          height: "Altura",
          nameId: "Nombre en el ID",
          identificationNumber: "Número de Identificación",
          nationality: "Nacionalidad",
          martialStatus: "Estado Civil",
          single: "Soltero",
          married: "Casado",
          divorced: "Divorciado",
          widowed: "Viudo",
          occupation: "Ocupación",
          socialeMediaChannels: 'Redes Sociales',

          customerType: 'Tipo de Cliente',
          customerStatus: 'Estado de Cliente',
          gender: 'Genero',
          preferredContact: 'Preferred Contact Method',
          enableAll: 'Habilitar Todo',
          disableAll: 'Deshabilitar Todo',
          invoiceReminderLabel:
            'Ingrese cada cuantos días se enviara recordatorio',
          invoiceReminder: 'Recordatorios de facturas de activación',
          assetPickupRequest: 'Solicitud de recogida de activos',
          pickupAddress: 'Dirección de entrega',
          requireDeposit: 'Requerir depósito',
          lateFees: 'Factura de cargos por pago atrasado',
          lateFeesLabel: 'Ingrese el porcentaje de mora a cobrar',
          thisInvoice: 'Esta factura ha sido pagada',
          customerNewTitle: 'Crear un nuevo cliente',
          customerEditTitle: 'Editar cliente',
          categoryNewTitle: 'Crear una nueva categoría',
          creditNewTitle: 'Crear un nuevo crédito',
          categoryEditTitle: 'Editar categoría',
          creditEditTitle: 'Editar crédito',
          menuNewTitle: 'Crear un nuevo menú',
          workSheetNewTitle: 'Crear Hoja de Trabajo',
          menuEditTitle: 'Editar menú',
          workSheetEditTitle: 'Editar Hoja de Trabajo',
          productNewTitle: 'Crear elemento de menú',
          serviceNewTitle: 'Crear un servicio',
          productEditTitle: 'Editar elemento de menú',
          serviceEditTitle: 'Editar servicio',
          changePaymentSetting: 'Cambiar configuración del pago',
          shippingNewTitle: 'Crear un nuevo envío',
          shippingEditTitle: 'Editar envío',
          taxNewTitle: 'Crear un nuevo impuesto',
          taxEditTitle: 'Editar impuesto',
          tableNewTitle: 'Crear una nueva mesa',
          tableEditTitle: 'Editar mesa',
          packageNewTitle: 'Create a new package',
          packageEditTitleditTitle: 'Edit package',
          variantGroupEditTitle: 'Editar opción',
          variantGroupNewTitle: 'Crear opción',
          otherChargeNewTitle: 'Crear otro cargo',
          otherChargeEditTitle: 'Editar otro cargo',
          userNewTitle: 'Crear un nuevo miembro del staff',

          suscriptionNewTitle: 'Crear una nueva suscripción',

          driversNewTitle: 'Crear un nuevo chofer',
          userEditTitle: 'Editar miembro del staff',

          suscriptionEditTitle: 'Editar suscripción',

          driversEditTitle: 'Editar choferes',
          supportUsers: 'Usuarios de soporte',
          occupationNewTitle: 'Crear Nueva Ocupación/Trabajo',
          occupationEditTitle: 'Editar Ocupación/Trabajo',
          roleNewTitle: 'Agregar permisos',
          roleEditTitle: 'Editar rol',
          selectAProduct: 'Seleccione un elemento de menú',
          selectACategory: 'Seleccione una categoría',
          selectACustomer: 'Seleccione un cliente',
          selectATax: 'Seleccione un impuesto',
          selectARestaurant: 'Seleccione un negocio',
          selectAState: 'Seleccione un estado',
          filterCategory: 'Filtre...',
          selectALanguage: 'Idioma',
          selectAnOccupation: 'Seleccione un puesto',
          selectACooker: 'Seleccione un cocinero',
          selectADriver: 'Seleccione un chofer',
          allProducts: 'Todos los elementos de menú:',
          settingEditTitle: 'Editar configuración',
          generalSettingEditTitle: 'Editar configuraciones básicas',
          generalSettingNewTitle: 'Crear configuraciones básicas',
          keySettingEditTitle: 'Editar configuraciones del sistema',
          keySettingNewTitle: 'Crear configuraciones del sistema',
          funSettingEditTitle: 'Configuraciones de Funcionamiento',
          funSettingNewTitle: 'Crear configuraciones de funcionamiento',
          settingNewTitle: 'Añadir configuración',
          pickFromSelect: 'Seleccionar inicio de recogida',
          pickToSelect: 'Seleccionar fin de recogida',
          dateFromSelect: 'Seleccionar fecha de inicio',
          dateToSelect: 'Seleccionar fecha de fin',
          cancelOrder: 'Cancelar orden',
          drivers: 'Choferes',
          customer: 'Cliente',
          date: 'Fecha',
          startDate: 'Fecha de Inicio',
          endDate: 'Fecha de Fin',
          orderType: 'Tipo de orden',
          addressToDelivery: 'Dirección de entrega',
          hourToPick: 'Hora de recogida',
          tableService: 'Mesa de servicio',
          products: 'Elementos de menú',
          services: 'Servicios',
          otherCharges: 'Otros cargos',
          shippingPrice: 'Precio de entrega',
          subtotal: 'Subtotal',
          tax: 'Total de impuestos',
          tip: 'Propina',
          total: 'Total',
          number: 'Número',
          doYou: '¿Realmente desea eliminar',
          marked: 'registros marcados?',
          pendingPay: 'Pendiente de pago',
          payed: 'Pagado',
          notes: 'Notas',
          cancelNotes: 'Notas de cancelación',
          pickupNotes: 'Notas de recogida',
          cooker: 'Cocinero',
          state: 'Estado',
          generalConfiguration: 'CONFIGURACIONES GENERALES',
          paymentConfiguration: 'CONFIGURACIONES DEL PAGO',
          cashDiscount: 'DESCUENTO DE EFECTIVO',
          eposConfiguration: 'CONFIGURACIONES EPOS',
          emailConfiguration: 'CONFIGURACIONES DE EMAIL',
          twilioSMS: 'MENSAJERÍA CON TWILIO',
          sinchSMS: 'MENSAJERÍA CON SINCH',
          selectAVariantGroup: 'Selecciona una opción',
          imageText:
            'Por favor suba imágenes de 200x200 para obtener mejores resultados. Asegúrese de que la imágen no esté bajo derechos de autor.',
          orderCateringForm: 'Aprobación de la orden de catering',
          restaurantHours: 'Horario del Negocio',
          deadlinesNotes:
            'Por favor, asegúrese que la sumatoria de los plazos es 100.',
          selectDate: 'Seleccione fecha',
          toPay: 'A pagar',
          pending: 'Pendiente',
          genaral: 'General',
          others: 'Otros',
          variants: 'Variantes',
          sides: 'Acompañantes',
          ingredients: 'Ingredientes',
          shift4: 'Shift4',
          auth: 'Authorize.Net',
          capcha: 'Capcha',
          zipCodes: 'Códigos postales',
          backups: 'Backups',
          devices: 'Dispositivos',
          creditSetting: 'Configuración de Crédito'
        },
        fields: {
          createNewCustomer: 'Crear nuevo cliente',
          editItem: 'Editar elemento',
          previewInvoice: 'Vista previa de factura',
          companyName: 'Nombre de la compañía',
          companyEmail: 'Correo Electrónico de la Empresa',
          companyPhone: 'Teléfono de la Empresa',
          companyTitle: 'Puesto de Trabajo',
          companyWebSite: 'Sitio Web de la Empresa',
          companyIndustry: 'Industria de la Empresa',
          addNewCustomer: 'Añadir nuevo cliente',
          projectName: 'Nombre del proyecto',
          billingAddress: 'Dirección de facturación',
          selectCustomerAttachBillingAddress: 'Seleccione un cliente para adjuntar una dirección de facturación',
          shippingAddress: 'Dirección de envío',
          selectCustomerAttachShippingAddress: 'Seleccione un cliente para adjuntar una dirección de envío',
          selectedAddress: 'Dirección seleccionada:',
          changeAddress: 'Cambie una',
          addAddress: 'Añadir una',
          number: 'Número',
          username: 'Nombre de usuario',
          emailLabel: 'Correo electrónico',
          phoneLabel: 'Teléfono',
          firstNameLabel: 'Nombre',
          lastNameLabel: 'Apellido',
          putEmail: 'Ingrese su correo electrónico',
          putPhone: 'Ingrese su teléfono',
          putFirstName: 'Ingrese su nombre',
          putLastName: 'Ingrese su apellido',
          putUserName: 'Ingrese su nombre de usuario',
          takePicture: 'Tomar Foto',
          accept: 'Aceptar',
          hidde: 'Ocultar',
          delete: 'Eliminar',
          retake: 'Volver a tomar',
          previewPhoto: 'Vista previa de foto',
          previewAcceptedPhoto: 'Vista previa de foto aceptada',
          viewImenuBookControlPanel: 'Ver iMenuBooks en el Panel de control',
          viewImenuEngageControlPanel: 'Ver iMenuEngage360 en el Panel de control',
          viewImenuBookOptions: 'Ver opciones de iMenuBooks',
          viewOrdersOption: 'Ver opción de Ordenes',
          viewReservationOption: 'Ver opción de Reservaciones',
          viewInvoiceOption: 'Ver opción de Facturas',
          viewQuoteOption: 'Ver opción de Cotizaciones',
          changeImage: 'Cambiar Imagen',
          addImage: 'Añadir Imagen',
          customerHours: 'Personalizar Horas',
          name: 'Nombre',
          menuName: 'Nombre del menú',
          description: 'Descripción',
          email: 'Email',
          password: 'Contraseña',
          date: 'Fecha',
          image: 'Imagen',
          phone: 'Teléfono',
          productMin: 'Mínimo de elementos de menú',
          productMax: 'Máximo de elementos de menú',
          price: 'Precio',
          extraCharge: 'Cargo Extra',
          costPrice: 'Costo',
          retailPrice: 'Venta',
          stimateTime: 'Stimate Time (minutes)',
          stockQuantity: 'Cantidad en Stock',
          minReorderPoint: 'Cantidad Mínima en Stock',
          maxReorderPoint: 'Cantidad Máxima en Stock',
          CreditAmount: 'Total del Crédito',
          vendorName: 'Nombre del Distribuidor',
          vendorCode: 'Código del Distribuidor',
          shortDescription: 'Descripción Corta',
          keywords: 'Palabras Claves',
          tags: 'Etiquetas',
          binNumber: 'Número Bin',
          addSerialNumber: 'Número Serial Add',
          active: 'Activar',
          save: 'Ahorrar',
          submitToken: 'Enviar Token',
          available: 'Disponible',
          availableCategories: 'CATEGORÍAS DISPONIBLES',
          availableProducts: 'ELEMENTOS DE MENU DISPONIBLES',
          availableStaff: 'TRABAJADORES DISPONIBLES',
          selectedProducts: 'ELEMENTOS DE MENU SELECCIONADOS',
          selectedCategories: 'CATEGORÍAS SELECCIONADAS',
          selectedStaff: 'TRABAJADORES SELECCIONADOS',
          workedHours: 'HORAS TRABAJADAS',
          scheduledDates: 'Fechas programadas',
          selectedAggregates: 'AGREGADOS SELECCIONADOS',
          marketingConsent: 'LABOR DE MARKETING',
          product: 'Elemento de menú',
          category: 'Categoría',
          tax: 'Impuesto',
          parentCategory: 'Categoría padre',
          qrCode: 'Código QR',
          capacity: 'Capacidad',
          percent: 'Porcentaje',
          priority: 'Prioridad (0 - 1)',
          permissions: 'Permisos',
          permissionsRole: 'Roles de Permiso',
          selectCashDiscount: 'Seleccione Descuento por pronto pago',
          roles: 'Puesto/Trabajo',
          address: 'Dirección',
          title: 'Título',
          subtitle: 'Subtítulo',
          online: 'En Línea',
          showOtherRestaurant: 'Mostrar otros negocios',
          reservationByTable: 'Reserva una mesa',
          reservationByStaff: 'Reservar trabajador',
          tablesChoose: 'Los clientes pueden escoger ubicación de la mesa',
          onlineMss: 'Negocio no está visible para el público ',
          onlineMss1: 'Negocio visible para el público ',
          mustClockinMss: 'Usted debe marcar la entrada primero. Por favor, ',
          mustClockin2Mss: 'marque la entrada.',
          SelectPickHour: 'Seleccionar hora de recogida',
          SelectPickHour2: 'Activar hora de recogida',
          TipRequire: 'Propina obligatoria',
          tips: 'Propinas',
          assetPickup: 'Recogida de activos',
          depositAmount: 'Cantidad del depósito',
          typeTip: 'Escriba un porciento de propina',
          MinTimeToCook: 'Tiempo mínimo de cocción',
          PickFrom: 'Recoger a partir de',
          PickToToolTip: 'Agrega el final de tu tiempo de entrega',
          PickFromToolTip: 'Agrega el inicio de tu tiempo de entrega',
          PickTo: 'Recoger hasta',
          DateFrom: 'Fecha de Inicio',
          DateTo: 'Fecha de Fin',
          DateLimit: 'Fecha límite de pago',
          ShowCooker: 'Muestra cocinero',
          zipCodes: 'Código zip',
          deliveryZone: 'Zonas de entrega',
          cooker: 'Cocinero',
          driver: 'Chofer',
          rejectedOrder: 'Orden rechazada por la conductora',
          cancelationNote: 'Nota de cancelación',
          tableNumber: 'Número de mesa',
          firstName: 'Nombre(s)',
          lastName: 'Apellidos',
          occupation: 'Puesto',
          confirmPassword: 'Confirme contraseña',
          endPointUrl: 'Endpoint Url',
          capchaKey: 'Capcha key',
          clientGuid: 'Client GUID',
          interfazVersion: 'Versión de la interfaz',
          interfazName: 'Nombre de la interfaz',
          apiLoginId: 'API login Id',
          epos: 'Integración con ePos',
          eposToken: 'ePos token',
          transactionKey: 'Transaction Key',
          smtpHost: 'SMTP Host',
          port: 'Puerto',
          secure: 'Seguro',
          twFromNumber: 'Número de origen',
          twAccountSID: 'SID de la cuenta',
          twToken: 'Token',
          sinchFromNumber: 'Número de origen',
          sinchAccountSID: 'Id del plan de servicio',
          sinchToken: 'Token',
          web: 'Sitio web',
          variantGroup: 'Opciones',
          haveSides: 'Agregados',
          cantOfSides: 'Cantidad de agregos incluidos',
          categoryOfSides: 'Filtre los agregos por categoría',
          addIngredients: 'Especificar ingredientes',
          typeAnIngredient: 'Entre un ingrediente',
          canViewGeoposition: 'Puede ver geolocalización',
          canViewRating: 'Puede ver el rating',
          viewDelivery: 'Puede crear órdenes de entrega',
          viewOnTable: 'Puede crear órdenes en la mesa',
          viewCurbside: 'Puede crear órdenes para recoger en auto',
          tablePrefix: 'Prefijo de mesa',
          barPrefix: 'Prefijo de barra',
          roomPrefix: 'Prefijo de habitación',
          typeZipCode: 'Escriba un zipcode',
          isCatering: 'Es de catering',
          isService: 'Menú de servicio',
          isReservationMenu: 'Menú de reservación',
          catering: 'Catering',
          minAmoutCatering: 'Monto mínimo para catering',
          minAmountCateringDelivery: 'Monto mínimo para envío',
          loyaltyMinPointToBuy: 'Mínimo de puntos para comprar',
          loyaltyExpirationMonths:
            'Cantidad de meses para expiración del loyalty program',
          loyaltyPointMoney: 'Cantidad de puntos por $1',
          partialPay: 'Pagos parciales',
          payForQuotation: 'Pre pago por cotización',
          percentPayForQuotation: 'Monto de pre pago por cotización',
          service: 'Servicio',
          showServicePrice: 'Mostrar precio del servicio',
          viewCatering: 'Ver catering',
          viewLoyalty: 'Ver loyalty program',
          viewReservation: 'Ver reservación',
          reservation: 'Reservación',
          loyalty: 'Programa de Loyalty',
          minDayToReservation: 'Margen de reserva',
          viewCustomerReservation: 'Ver reservaciones de clientes',
          sameHourForAllDays: 'El mismo horario para todos los días',
          followingDays: 'Mismo horario para los siguientes días.',
          timezone: 'Timezone',
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo',
          allDays: 'Todos los días',
          marginDays: 'Minima cantidad de días para orden',
          cateringStates: 'Estados para catering',
          typeState: 'Escriba el código del estado',
          zipCodesExclude: 'Zipcodes a excluir',
          cateringEvents: 'Eventos de catering',
          typeEventName: 'Escribe un nombre del evento',
          proposeNewDataTime: 'Proponer nueva fecha/hora',
          fixed: 'Monto fijo',
          amount: 'Monto',
          discount: 'Descuento',
          deadlines: 'Plazos',
          pendingPay: 'Pendiente de pago',
          payed: 'Pagado',
          states: 'Estados',
          paymentMethod: 'Método de pago',
          cash: 'Efectivo',
          card: 'Tarjeta',
          check: 'Cheque',
          free: 'Libre',
          busy: 'Ocupado',
          dirty: 'Sucio',
          authenticationToken: 'Token de autorización',
          authenticationTokenMoto: 'Token de autorización para MOTO',
          authenticationTokenFB: 'Token de autorización para FB',
          accountType: 'Tipo de cuenta',
          method: 'Método',
          serverName: 'Nombre del dependiente',
          urlLocation: 'Url de la localización',
          fax: 'Fax',
          oldServerId: 'Antiguo Employee ID',
          newServerId: 'Nuevo Employee ID',
          acivateTwilio: 'Activar Twilio',
          acivateSinch: 'Activar Sinch',
          isDriver: 'Es un chofer',
          monthy: 'Mensual',
          anual: 'Anual',
          merchantOnboardingApplication:
            'Aplicación de incorporación de comerciantes',
          applicationName: 'Nombre del aplicación',
          agentId: 'ID del agente',
          planId: 'ID del plan',
          dateOfBirth: 'Fecha de nacimiento',
          equityOwnershipPercent: 'Porcentaje de propiedad accionaria',
          isPersonalGuarantor: '¿Es Garantía Personal?',
          showProgressBar: 'Mostrar barra de progreso a la conductora',
          paymentManagement: 'Gestión de Pagos'
        },
        messages: {
          buttons: {
            ok: 'Ok',
            dismiss: 'Descartar'
          },
          activatePaymentMethod: 'ha sido activado.',
          incorrectToken: 'El token enviado no es correcto.',
          activationMethodError:
            'El método de activación ha devuelto un error.',
          unexpectedError: 'Ha ocurrido un error inesperado.',
          savePaymentMethodSuccess:
            'Se ha guardado la configuración del método de pago.',
          savePaymentMethodError:
            'Ha ocurrido un error al guardar la configuración del método de pago.'
        },
        validate: {
          emailExisteTitle: 'El correo electrónico ya existe',
          emailExistMessage: 'Este correo electrónico ya está registrado. Utilice una dirección de correo electrónico diferente o solicite al usuario que haga clic en Olvidé mi contraseña en la pantalla de inicio de sesión.',
          validate: 'Validación',
          validateCategory: 'Validar categoría',
          validateCustomer: 'Validar cliente',
          validateMenu: 'Validar menú',
          validateOtherCharge: 'Validar otros cargos',
          validateProduct: 'Validar elemento de menú',
          validateShipping: 'Validar envío',
          validateTable: 'Validar mesa',
          validateTax: 'Validar impuesto',
          validateUser: 'Validar usuario',
          validateRole: 'Validar rol',
          validateSetting: 'Validar configuración',
          validateOccupation: 'Validar puesto',
          validateVariantGroup: 'Validar opción',
          name: 'El nombre es requerido',
          image: 'La imagen es requerida',
          email: 'El email es requerido',
          phone: 'El teléfono es requerido',
          emailIncorrect: 'El email es incorrecto',
          date: 'La fecha es requerida',
          selectedCategories: 'Debe seleccionar al menos una categoría',
          productMinNumber:
            'Los elementos de menú mínimos debe ser un valor numérico',
          productMaxNumber:
            'Los elementos de menú máximos debe ser un valor numérico',
          productMinGreater:
            'Los elementos de menú mínimos deben ser mayor que 0',
          productMaxGreater:
            'Los elementos de menú máximos deben ser mayor de 2',
          price: 'El precio debe ser numérico',
          priceGreater: 'El precio debe ser mayor que 0',
          product: 'Debe seleccionar un elemento de menú',
          costPriceNumber: 'El precio de costo debe ser un valor numérico',
          retailPriceNumber: 'El precio de venta debe ser un valor numérico',
          retailPriceShouldBeGreaterThanSalePrice:
            'El Precio de Venta al Público siempre debe ser mayor que el Precio de Oferta.',
          costPriceGreater: 'El precio de costo debe ser mayor que 0',
          retailPriceGreater: 'El precio de venta debe ser mayor que 0',
          category: 'Debe seleccionar una categoría',
          capacity: 'La capacidad debe ser numérica',
          capacityGreater: 'La capacidad debe ser mayor que 0',
          percent: 'El porciento es requerido',
          percentGreater: 'El porciento debe ser mayor que 0',
          password: 'El password es requerido',
          address: 'La dirección es requerida',
          title: 'El título es requerido',
          subtitle: 'El subtítulo es requerido',
          zipCode: 'El zip code no es un zip code válido',
          duplicateZipCode: 'El zip code ya se encuentra en la lista',
          cateringPriceZero: 'El precio del catering es cero',
          cooker: 'Debe llenar el campo cocinero',
          tableNumber: 'La mesa debe tener un número',
          tableNumberGreater: 'El número de la mesa debe ser mayor que 0',
          nameDuplicate:
            'Ya existe una mesa registrada con este nombre. Debe cambiar el número o el tipo.',
          firstName: 'Debe llenar el campo nombre(s)',
          lastName: 'Debe llenar el campo apellidos',
          confirmPassword:
            'La contraseña y la contraseña de confirmación deben ser iguales',
          occupation: 'Debe llenar el campo puesto',
          notes: 'Debe poner una nota de cancelación',
          tip: 'El impuesto no puede ser cero',
          tipRepeat: 'El impuesto existe. Por favor, escriba un nuevo número.',
          emailDontExist: 'El email no existe',
          ingredient: 'El ingrediente ya existe.'
        },
        permissionsGroup: {
          permissionMenu: 'PERMISOS  DE MENÚS',
          permissionCategory: 'PERMISO DE CATEGORÍAS',
          permissionProduct: 'PERMISO DE ELEMENTOS DE MENU',
          permissionSpecialPrice: 'PERMISO DE PRECIOS ESPECIALES',
          permissionCustomer: 'PERMISOS DE CLIENTES',
          permissionCredit: 'PERMISOS DE CRÉDITOS',
          permissionHouseAccount: 'PERMISOS DE CUENTAS DE LA CASA',
          permissionTable: 'PERMISOS DE MESAS',
          permissionTax: 'PERMISOS DE IMPUESTOS',
          permissionShipping: 'PERMISOS DE ENVÍOS',
          permissionOtherCharge: 'PERMISOS DE RECARGOS',
          permissionUser: 'PERMISOS DE STAFF',
          permissionDriver: 'PERMISO DE SUPERVICIÓN DEL CONDUCTOR',
          permissionDeliveryDriver: 'PERMISO DEL CONDUCTOR DE ENTREGA',
          permissionOrder: 'PERMISOS DE ÓRDENES',
          permissionRole: 'PERMISOS DE ROLES',
          permissionWorkSheet: 'PERMISOS DE HOJAS DE TRABAJO',
          permissionSetting: 'PERMISOS DE CONFIGURACIÓN',
          permissionPayment: 'PERMISOS DE PAGO',
          permissionReport: 'PERMISO DE INFORMES',
          permissionClockin: 'PERMISOS DE ENTRADA',
          permissionOccupation: 'PERMISOS DE PUESTOS',
          permissionVariantGroup: 'PERMISOS DE OPCIONES DE ELEMENTOS DE MENU',
          permissionReservation: 'PERMISOS DE RESERVACIÓN',
          permissionSuscriptors: 'PERMISOS DE SUSCRIPCIÓN',
          permissionSuscription: 'SUBSCRIPTION PERMISSION',
          canViewMenu: 'Puede ver menús',
          canCreateMenu: 'Puede crear menús',
          canEditMenu: 'Puede editar menús',
          canDeleteMenu: 'Puede eliminar menús',
          canViewCategory: 'Puede ver categorías',
          canCreateCategory: 'Puede crear categorías',
          canEditCategory: 'Puede editar categorías',
          canDeleteCategory: 'Puede eliminar caegorías',
          canViewProduct: 'Puede ver elementos de menú',
          canCreateProduct: 'Puede crear elementos de menú',
          canEditProduct: 'Puede editar elementos de menú',
          canDeleteProduct: 'Puede eliminar elementos de menú',
          canViewSpecialPrices: 'Puede ver precios especiales',
          canCreateSpecialPrices: 'Puede crear precios especiales',
          canEditSpecialPrices: 'Puede editar precios especiales',
          canDeleteSpecialPrices: 'Puede eliminar precios especiales',
          canViewCustomer: 'Puede ver clientes',
          canCreateCustomer: 'Puede crear clientes',
          canEditCustomer: 'Puede editar clientes',
          canDeleteCustomer: 'Puede eliminar clientes',
          canViewCredit: 'Puede ver créditos',
          canCreateCredit: 'Puede crear créditos',
          canEditCredit: 'Puede editar créditos',
          canDeleteCredit: 'Puede eliminar créditos',
          canViewHouseAccount: 'Puede ver cuentas de la casa',
          canCreateHouseAccount: 'Puede crear cuentas de la casa',
          canCreateSuscriptor: 'Puede crear suscriptores',
          canViewSuscriptor: 'Puede ver suscriptores',
          canEditSuscriptor: 'Puede editar suscriptores',
          canDesactivateSuscriptor: 'Puede desactivar suscriptores',
          canViewTable: 'Puede ver mesas',
          canCreateTable: 'Puede crear mesas',
          canEditTable: 'Puede editar mesas',
          canDeleteTable: 'Puede eliminar mesas',
          canViewTax: 'Puede ver impuestos',
          canCreateTax: 'Puede crear impuestos',
          canEditTax: 'Puede editar impuestos',
          canDeleteTax: 'Puede eliminar impuestos',
          canViewShipping: 'Puede ver envíos',
          canCreateShipping: 'Puede crear envíos',
          canEditShipping: 'Puede editar envíos',
          canDeleteShipping: 'Puede eliminar envíos',
          canViewOtherCharge: 'Puede ver otros cargos',
          canCreateOtherCharge: 'Puede crear otros cargos',
          canEditOtherCharge: 'Puede editar otros cargos',
          canDeleteOtherCharge: 'Puede eliminar otros cargos',
          canViewUser: 'Puede ver usuarios',
          canCreateUser: 'Puede crear usuarios',
          canEditUser: 'Puede editar usuarios',
          canDeleteUser: 'Puede eliminar usuarios',
          canViewDriver: 'Puede ver choferes externos',
          canCreateDriver: 'Puede crear choferes externos',
          canEditDriver: 'Puede editar choferes externos',
          canDeleteDriver: 'Puede eliminar choferes externos',
          canViewDeliveryDriver: 'Puede ver el conductor de entrega',
          canEditDeliveryStatus: 'Puede editar el estado de entrega',
          canCreateDeliveryDriver: 'Puede crear un conductor de entrega',
          canDeleteDeliveryDriver: 'Puede eliminar el conductor de entrega',
          canViewOccupation: 'Puede ver puestos',
          canCreateOccupation: 'Puede crear puestos',
          canEditOccupation: 'Puede editar puestos',
          canDeleteOccupation: 'Puede eliminar puestos',
          canViewRole: 'Puede ver roles',
          canCreateRole: 'Puede crear roles',
          canEditRole: 'Puede editar roles',
          canDeleteRole: 'Puede eliminar roles',
          canViewWorkSheet: 'Puede ver hojas de trabajo',
          canCreateWorkSheet: 'Puede crear hojas de trabajo',
          canEditWorkSheet: 'Puede editar hojas de trabajo',
          canDeleteWorkSheet: 'Puede eliminar hojas de trabajo',
          canViewOrder: 'Puede ver órdenes',
          canEditOrder: 'Puede editar órdenes',
          canCreateOrder: 'Puede crear órdenes',
          canViewOrderForDelivery: 'Puede ver órdenes para entregar',
          canChangeSetting: 'Puede cambiar las configuraciones',
          canViewVariantGroup: 'Puede ver opciones de elementos de menú',
          canCreateVariantGroup: 'Puede crear opciones de elementos de menú',
          canEditVariantGroup: 'Puede editar opciones de elementos de menú',
          canDeleteVariantGroup: 'Puede eliminar opciones de elementos de menú',
          canViewReservation: 'Puede ver reservaciones',
          canCreateReservation: 'Puede crear reservaciones',
          canEditReservation: 'Puede editar reservaciones',
          canDeleteReservation: 'Puede eliminar reservaciones',
          canViewPayment: 'Puede ver los pagos',
          canIgnoreClockin: 'Puede ignorar horario de entrada',
          canViewSalesByCustomer: 'Puede ver las ventas por cliente',
          canViewSalesByProduct: 'Puede ver las ventas por producto',
          canViewDynamicReports: 'Puede ver publicaciones dinámicas',
          canViewSubscription: 'Can view Subscription',
          canCreateSubscription: 'Can Create Subscription',
          canEditSubscription: 'Can Edit Subscription',
          canDeleteSubscription: 'Can delete Subscription'
        },
        marketingMessages: {
          orderInfo: 'Información de la orden',
          inKitchen:
            ', hola! Gracias por usar nuestro servicio. Su orden está en estos momentos en la cocina.',
          cooked: 'Su orden está lista y, luce genial!',
          delivering:
            'Su orden va de camino en estos momentos. Solo unos minutos más, por favor.',
          delivered: 'Su orden ha sido entregada. Bon appétit!',
          canceled: 'Su orden ha sido cancelada',
          cateringApproved:
            ', su orden de catering ha sido aprobada. Por favor, revise su email para ver los detalles de la orden.',
          cateringCancel:
            ', lo sentimos, su orden de catering ha sido cancelada.',
          reservationChangeStatus: 'Cambio de estado de su reservación',
          reservationApproved: ' , hola! Su reservación ha sido aprobada para ',
          reservationApproved2: ', ahora necesita confirmar la reservación.',
          reservationProposedDateTime:
            ' , hola! Lamentamos no poder cumplir con la fecha/hora solicitada por usted. Le proponemos esta nueva fecha/hora: ',
          reservationRejected:
            ' , hola! Lamentamos tener que rechazar su reservación por falta de capacidad.',
          reservationCancel:
            'Su reservación ha sido cancelada. Si tiene alguna inquietud no dude en ponerse en contacto con nosotros.'
        }
      }
    },
    frontend: {
      menu: {
        clockInMessage: 'Has registrado correctamente',
        signIn: 'Iniciar Sesión',
        chatImenu: 'Soporte iMenuApps®',
        trackYourPackage: 'Seguimiento de su paquete',
        aboutImenu: 'Sobre iMenuapps®',
        seeLess: 'Ver menos',
        seeMore: 'Ver más',
        foodAndMoodJournal: 'Diario de comida y estado de ánimo',
        motivation: `Para ver tu historial de pedidos descarga la aplicación iMenuApps® y regístrate.
             <a href="https://apps.apple.com/us/app/imenuapps/id1574771438" target="_blank">Descargar en Apple App Store</a> o 
             <a href="https://play.google.com/store/apps/details?id=net.imenuapps.apps&hl=en_US&pli=1" target="_blank">Obtenerlo en Google Play</a>.`,
        motivationMobile:
          'Para ver tu historial de pedidos, regístrate con iMenuApps®.',
        menu: 'Menú',
        shop: 'Compras',
        ads: 'Anuncios Digitales',
        credit: 'Créditos',
        menuCatering: 'Menú de Catering',
        pickupRequest: 'Solicitud de recogida',
        termsOfUse: 'Terminos de Uso',
        privacyPolicy: 'Politica de Privacidad',
        otherPolicy: 'Otras Politicas',
        reservation: 'Reservaciones',
        about: 'Quiénes somos',
        oferts: 'Ofertas',
        contact: 'Contactanos',
        init: 'Inicio',
        loginMerchant: 'Inicio sesión comerciante',
        loginClient: 'Inicio sesión cliente',
        editProfile: 'Edita tu perfil',
        edit: 'Modificar sus datos',
        log: 'Sign In / Registrar',
        membersLogin:'Inicio de sesión de miembros',
        membersRegister: 'Registro de miembros',
        merchantsLogin:'Inicio de sesión de comerciantes',
        catering: 'Servicio de Catering',
        logout: 'Cerrar Sesión',
        logIn: 'Iniciar Sesión',
        profil: 'Su Cuenta',
        profil1: 'Perfil',
        createUser: 'Registrarse',
        forgotPassword: 'Olvidó su contraseña?',
        passwordReset: 'Restablecer contraseña',
        newPassword: 'Nueva Contraseña',
        newData: 'Modificar sus datos',
        confirmPassword: 'Confirmar Contraseña',
        register: 'Registrar',
        orders: 'Órdenes',
        restaurant: 'Seleccione el Tipo de Negocio abajo',
        restablacerPassword: 'Restablecer Contraseña',
        updateData: 'Actualizar Información',
        mssForgotPassword: 'Hemos mandado una nueva contraseña a su correo.',
        errorLogIn: 'Correo o contraseña incorrecto',
        errEmailExist: 'Esta email ya existe',
        errPassNotCoinc: 'No coincide con el nuevo password',
        userNotFound: 'Correo incorrecto',
        refresh: 'Refrescar',
        mssUpdateData: 'Sus datos se actualizaron correctamente',
        mssCreateUser:
          'Cliente creado correctamente, hemos enviado su nueva contraseña por correo.',
        mssPasswordChangedCorrectly: 'Contraseña actualizada correctamente',
        ticketMenu: 'Ticket Abierto'
      },
      app: {
        convertToProd: 'Convertir Prueba en Producción',
        convert: 'Convertir',
        daysOfTrial: 'Dias de prueba',
        trialExpired: 'Prueba Expirada',
        trialMessageExpired: 'Su prueba gratuita de iMenuApps® ha caducado. Para continuar usando todo el poder de iMenuApps®, compre una licencia ahora y desbloquee todas las funciones. Envíenos un correo electrónico con el nombre de su empresa a support@imenuapps.com',
        allBusiness: 'Todos los Negocios',
        hospitality: 'Hospitality',
        reservations: 'Reservaciones',
        service: 'Servicio',
        entertainment: 'Entretenimiento',
        retail: 'Minorista',
        fullText:
          'Presentamos iMenuApps®: su solución comercial integral con portal de cliente mejorado iMenuApps® presenta una plataforma integral diseñada para satisfacer todas las necesidades comerciales, revolucionando la forma en que opera y se conecta con sus clientes. Nuestra aplicación no solo permite a las empresas optimizar las operaciones y aumentar las ventas, sino que también incorpora un portal de clientes de vanguardia que mejora la experiencia del cliente. Con nuestro portal de clientes, los clientes pueden volver a pedir productos y servicios sin esfuerzo y mantener un registro completo de sus transacciones y perfiles con cada comerciante con el que interactúan en nuestra plataforma. Esta característica fomenta la conveniencia, la eficiencia y las interacciones personalizadas, lo que en última instancia fortalece el vínculo entre las empresas y sus valiosos clientes. Ya sea que opere en hotelería, comercio minorista, servicios o entretenimiento, iMenuApps® es la solución definitiva adaptada a los requisitos específicos de su industria. Nuestra plataforma avanzada integra a la perfección el portal del cliente, lo que permite a las empresas brindar una experiencia perfecta y personalizada a su clientela. Adopte iMenuApps® y abra un mundo de posibilidades para su negocio. Benefíciese de nuestra interfaz de usuario intuitiva, funcionalidad robusta e infraestructura segura, todo orientado a optimizar las operaciones y fomentar relaciones duraderas con los clientes.',
        thisPay: 'Este Pago Realizado',
        thisPayDone: 'Este pago ha sido ya realizado.',
        selectOrder: 'Seleccione su tipo de orden',
        selectDetail: 'Su información',
        deliver: 'Entrega',
        pickup: 'Recogida',
        table: 'Mesa',
        curbside: 'En Auto',
        notClient:
          'No existen ordenes asociadas a este cliente. Recuerde que solo las pedidos de clientes registrados se podrán consultar.',
        getOrder: 'Para consultar órdenes',
        editTitle: 'Modifique sus datos',
        notPermissionForRating:
          'Solo los usuarios registrados pueden calificar negocios',
        thanksForRating: 'Gracias por calificarnos',
        sessionExpired:
          'Su sesión ha caducado por inactividad. Inicie sesión de nuevo.',
        notRestaurantFound:
          'No existe el negocio solicitado. Esperemos encuentre uno de su preferencia en nuestro listado.',
        all: 'Todos',
        productsAndServices: 'Ventas',
        reservation: 'Reservas'
      },
      product: {
        title: 'Elementos de menú de ',
        back: 'Atrás',
        noProducts:
          'Upss! Lo sentimos, esta categoría aún no tiene elementos de menú. ',
        productDetail: 'Detalles del elemento de menú',
        massageToast: 'Operación satistactoria ',
        productNote: 'Inserte aquí notas del elemento de menú...',
        productWithVariant: 'Clic ADICIONAR para otras opciones'
      },
      home: {
        country: 'Pais',
        stateProvince: 'Estado/Provincia/Región',
        county: 'Condado',
        autocomplete:
          'Comience a ingresar su dirección aquí para completar automáticamente',
        selectCategory: 'Categorías del menú',
        cardTitle: 'Detalles del carrito',
        cardheader: 'Elementos de menú',
        cancel: 'Cancelar',
        acept: 'Ok',
        confirm: 'Confirmar',
        clear: 'Limpiar',
        checkout: 'Verificar',
        deliverDetail: 'Detalles de la entrega',
        address: 'Dirección',
        pickupDetail: 'Detalles de la recogida',
        curbsideDetail: 'Detalles de la recogida en auto',
        cateringDate: 'Fecha del catering',
        pickTime: 'Horario de recogida no disponible. ',
        tableQr: 'QR de su ubicación',
        notValidQr: 'Código QR no válido',
        notSeatAvailable: 'Este asiento ya está asignado',
        errorRequired: 'Inserte la información requerida',
        errorDateNotValid: 'Fecha no válida',
        noProductForReorder:
          'No hay disponiblidad de ningun elemento de menú de esta orden.',
        noProductAvailable:
          'Los siguientes elementos de menú no aparecen en la orden, por noestar disponibles el día de hoy.',
        clientRequired:
          'Acción solo permitida para usuarios registrados. Inicia sesión',
        cantNotValid: 'Cantidad de elementos de menú no es válida',
        zipCodeNotValid: 'ZipCode no válido.',
        notZoneToDeliver: 'Actualmente no entregamos en esta área.',
        state: 'Estado',
        city: 'Ciudad',
        notValidEmail: 'Email no válido',
        reqSuccess: 'Enviada exitosamente la solicitud de cambio!',
        approveSuccess: 'Approuvé avec succès la demande de modification!',
        alertDeleteData: 'Desea volver a empezar?',
        notTimeToPick: 'Horario de recogida entre: ',
        cookTime: '. El tiempo estimado de cocción es de ',
        priceEstimated: 'Estimado',
        minuts: ' minutos.',
        selectOrderType: 'Por favor elija su tipo de pedido',
        search: 'Buscar',
        aggregateFree: 'Incluidos Gratis',
        sides: 'Agregos',
        choises: 'Ingredientes',
        variants: 'Variantes',
        withoutIngredients: 'Sin opciones',
        eventType: 'Tipo de Evento',
        emailSended: 'Correo enviado',
        choseView: 'Opciones de Vistas',
        applicationCreateSuccess: 'Aplicación creada con éxito',
        applicationCreateError: 'Se produjo un error al crear la aplicación'
      },
      genderOptions: {
        male: 'Hombre',
        female: 'Mujer',
        nonBinary: 'No Binario',
        transgenderMale: 'Hombre Transgénero',
        transgenderFemale: 'Mujer Transgénero',
        genderqueer: 'Genderqueer',
        genderfluid: 'Fluido de Género',
        agender: 'Agénero',
        twoSpirit: 'Dos Espíritus',
        bigender: 'Bigénero',
        demiboy: 'Demichico',
        demigirl: 'Demichica',
        androgynous: 'Andrógino',
        intersex: 'Intersexual',
        neutrois: 'Neutrois',
        pangender: 'Pangénero',
        polygender: 'Poligénero',
        preferNotToSay: 'Prefiero no decirlo',
        other: 'Otro'
      },
      orderType: {
        customerType: 'Tipo de Cliente',
        lastContacted: 'Ultima vez Contactado',
        nextFollowUp: 'Siguiente vez a Contactar',
        preferredContactTime: 'Hora de contacto preferida desde',
        preferredContactToTime: 'Hora de contacto preferida hasta',
        order: 'Orden',
        invoice: 'Factura',
        quote: 'Cotización',
        email: 'Correo',
        password: 'Contraseña',
        emailPhone: 'Correo y Teléfono',
        name: 'Nombre y Apellidos',
        phone: 'Teléfono',
        address: 'Dirección',
        code: 'Código Zip',
        pickDate: 'Fecha de Recogida',
        pickOut: 'Hora de Recogida',
        licencePlate: 'Matrícula',
        vehicleModel: 'Marca / modelo del vehículo',
        vehicleColor: 'Color del vehículo',
        contactedBy: 'Contactar por',
        tellContact: 'Díganos cómo contactarlo mejor',
        worker: 'Trabajador',
        minAmountDelivery: 'Monto mínimo para Catering',
        minAmountPickUp: 'Monto mínimo para Catering de Recogida'
      },
      reservation: {
        availability: 'Hora de reservaciones semanales',
        reservations: 'Reservaciones',
        reservationDetail: 'Detalle de la Reservación',
        create: 'Nueva Reservación',
        reservationDate: 'Fecha de la Reservación',
        reservationHour: 'Hora de la Reservación',
        timezone: 'Timezone',
        peoples: 'Personas',
        serviceTime: 'Tiempo Estimado del Servicio',
        reason: 'Ocasión',
        find: 'Buscar Reservación',
        enterCode: 'Inserte el código',
        yoursReservations: 'Reservaciones',
        code: 'Código',
        completeDateReservacion: 'Fecha',
        notcodefind: 'No se encontró reservación asociada a este código',
        state0: 'Solicitada',
        state1: 'Aprobada',
        state2: 'Fecha / Hora Propuesta',
        state3: 'Rechazada',
        state4: 'Confirmada',
        state5: 'Cancelada',
        state6: 'Cerrada',
        Monday: 'Lunes',
        Tuesday: 'Martes',
        Wednesday: 'Miércoles',
        Thursday: 'Jueves',
        Friday: 'Viernes',
        Saturday: 'Sábado',
        Sunday: 'Domingo',
        all: 'Todas',
        restaurantHour: 'Horario del Negocio',
        open: 'Abierto',
        close: 'Cerrado Ahora, continúe en la página',
        errorHourCaterin: 'Horario de Catering de ',
        errorHour: 'Horario de reserva de ',
        errorHour2: ' es de ',
        discount: 'Descuento',
        orderCloseToDiscount:
          'Reservación cerrada, y no se puede usar el pago de Cotización de la misma.',
        subtotalNotForDiscount:
          'No se puede usar el pago de Cotización porque es mayor que el Subtotal.',
        notDiscountToApply: 'No existe descuento para aplicar.',
        restaurantNotes: 'Nota del Negocio',
        quotationMessage1: 'Nuestra tarifa de cena prepaga es de  ',
        quotationMessage2:
          'y esta cantidad se deducirá de su pedido si realiza un pedido con nosotros. ',
        dinnerPrePayment: 'Prepago de Cena',
        timeToReserve: 'Tiempo a reservar',
        available: 'Disponibilidad',
        notAvailable: 'No Disponibilidad',
        deposit: 'Depósito de Reservación',
        seatsAvailable: ' Asientos Disponibles',
        guestLocation: 'Seleccione la ubicación de todos sus invitados',
        notGuestAvaibility: 'No existe disponibilidad para todos sus invitados',
        selectStaff: 'Seleccionar un personal'
      },
      order: {
        item: 'Articulo',
        description: 'Descripción',
        quantity: 'Cantidad',
        taxable: '¿Impuestos?',
        amount: 'Monto',
        discount: 'Descuento',
        creditCardFee: 'Tarifa de tarjeta de crédito',
        shipping: 'Envío',
        trackShipping: 'Seguimiento del envío',
        packagesManagement: 'Gestión de Paquetes',
        tax: 'Impuesto',
        deposit: 'Depósito',
        pendingAcceptance: 'Aceptación pendiente',
        accepted: 'Aceptada',
        prepare: 'Preparada',
        email: 'E-mail',
        phone: 'Phone',
        goBack: 'Go Back',
        orderDetail: 'Detalles del Pedido',
        quoteDetail: 'Detalles de la Propuesta',
        convertInvoice: 'Convertir a Factura',
        aceptQuote: 'Aceptar Propuesta',
        productServicesUpdated: 'Productos / Servicios actualizados',
        payInvoive: 'Pagar Factura',
        invoiceDetail: 'Detalles de la Factura',
        invoiceNumber: 'No. Factura',
        invoiceTerm: 'Términos',
        invoicePayed: 'Su factura ha sido pagado',
        shippingDate: 'Fecha de envío',
        shippingVia: 'Vía de Entrega',
        shippingTo: 'Entrega Desde',
        shippingFrom: 'Entrega Hacia',
        shippingTrackingNumber: 'Número de Rastreo',
        client: 'Cliente',
        cart: 'Carrito',
        productsOrdered: 'Productos Ordenados',
        products: 'Elementos de menú',
        name: 'Nombre',
        cant: 'Cant',
        price: 'Precio',
        total: 'Total',
        otherCharges: 'Otros cargos',
        quotationPayment: 'Pago de cotización',
        cashPayment: 'Pago en Cash',
        isTicket: 'Abrir orden como ticket',
        payAsTicket: 'Autorizar pago',
        sendInvoice: 'Emviar factura ',
        saveAsTicket: 'Salvar Ticket',
        checkPayment: 'Pago en Cheque',
        parcialPayment: 'Pago Parcial',
        quotationMessage1: 'Nuestra tarifa de cotización es de ',
        quotationMessage2:
          'y esta cantidad se deducirá de su pedido si realiza un pedido con nosotros. ',
        pendingPayment: 'Pago Pendiente',
        subtotal: 'Subtotal',
        taxe: 'Impuestos',
        deliver: 'Entrega',
        tip: 'Propina',
        notes: 'Notas',
        payment: 'Detalles del pago',
        ccard: 'Tarjeta de Crédito',
        ccode: 'Código de la tarjeta',
        payWithThisCardQuestion: '¿Deseas pagar con esta tarjeta?',
        cardEndingIn: 'Tarjeta terminada en',
        yesPayNow: 'Sí, pagar ahora',
        paymentSuccessful: 'Pago exitoso',
        paymentProcessed: 'Tu pago se procesó correctamente',
        expcard: 'Fecha de Expiración',
        dueDate: 'Fecha de Vencimiento',
        pay: 'Pagar',
        verify: 'Verificar Pago',
        transictionTitle: 'Estado de la Transacción',
        transictionOk: 'Transacción realizada correctamente',
        sendRequest: 'Enviar solicitud',
        requestCatering:
          'Solicitud enviada. El administrador del negocio lo contactará próximamente.',
        transictionError: 'Error ejecutando el pago',
        notValidCC: 'Tarjeta de crédito no válida',
        yourOrders: 'Ordenes ',
        yourTicket: 'Tickets ',
        seeAll: 'Ver todas sus órdenes',
        orderState: 'Estado de la orden',
        cooker: ' Cocinero',
        type: 'Tipo',
        state: 'Estado',
        messageToast:
          'Para conocer los cambios de estado de su pedido, inserte su correo electrónico o teléfono ',
        messgForContact:
          'Para conocer los cambios de estados de su orden, inserte su Correo o Teléfono',
        messgForContactCatering:
          'Debe iniciar sesión para crear orden de Catering',
        date: 'Fecha',
        state0: 'Pago Pendiente',
        state1: 'Pagada',
        state2: 'En Cocina',
        state3: 'Preparada',
        state4: 'En camino',
        state5: 'Entregada',
        state6: 'Cancelada',
        state7: 'Pendiente a revisión',
        state8: 'Catering Aprobada',
        state9: 'Propuesta',
        state10: 'Pedido recogido',
        state11: 'Demorado',
        state12: 'Anulado',
        state13: 'Reembolsado',
        notOrder: 'No tiene órdenes pendientes',
        transId: 'Transacción',
        invoice: 'Factura',
        invoiceProposal: 'Factura Propuesta',
        invoiceProposalUpdated: 'Factura Propuesta Actualizada',
        add: 'Adicionar',
        share: 'Compartir',
        remove: 'Eliminar',
        edit: 'Editar',
        cancelReason: 'Motivo de cancelación',
        paymentMethod: 'Método de pago',
        orderFor: 'Orden para',
        other: 'Otro',
        noTip: 'Sin Propina',
        payed: 'Pagado',
        toPay: 'Por Pagar',
        readyForPick:
          'Usted recibirá un email o un texto cuando su orden esté lista para recoger.',
        location: 'Ubicación',
        hourToPickEstimated: 'Hora estimada de recogida',
        dateToPickEstimated: 'Fecha estimada de recogida',
        routingNumber: 'Número de ruta bancaria',
        accountNumber: 'Número de cuenta',
        bankName: 'Nombre del banco',
        badroutingNumber: 'Número de ruta bancaria incorrecta',
        eventName: 'Nombre del Evento',
        guessNumber: 'Cantidad de Invitados',
        eventDate: 'Fecha del Evento',
        messageDevice: 'Comuníquese con el soporte en iMenuApps® para agregar un dispositivo al 973-969-1909 o support@solutionsforsuccess.net',
        eventStartHour: 'Hora de Inicio del Evento',
        eventEndHour: 'Hora de Fin del Evento',
        warningProductsTheOrderToCatering:
          'Está intentando agregar un elemento de menú que NO es del Servicio de Catering. Si desea continuar perderá los elementos de menú agregados anteriormente.',
        warningProductsTheCateringToOrder:
          'Está intentando agregar un elementos de menú del Servicio de Catering. Si desea continuar perderá los elementos de menú agregados anteriormente.',
        clientInfo: 'Información del cliente',
        orderType: 'Tipo de Orden',
        paymentByCard: 'Pagar por Tarjeta de Crédito',
        totalForPay: 'Total a pagar',
        firstName: 'Nombre(s)',
        lastName: 'Apellido(s)',
        postalCode: 'Código Postal',
        addressLine1: 'Dirección',
        updateTicket: 'Actualizar Ticket',
        closeTicket: 'Cerrar Ticket',
        closed: 'Cerrado',
        requiredCustomer: 'Datos del Cliente',
        requiredOrderType: 'Tipo de Orden',
        culumnNumber: 'Numero de columnas de la fila'
      },
      tooltips: {
        paymentManagement: 'Haga clic aquí para agregar o ver sus tarjetas guardadas',
        addOrder: 'Adicionar',
        printOrder: 'Imprimir',
        forward: 'Reenviar',
        reOrder: 'Reordenar',
        refreshOrder: 'Refrescar',
        refreshCaptcha: 'Refrescar Captcha',
        deleteOrder: 'Eliminar',
        readyProduct: 'Listo',
        printRes: 'Imprimir',
        shareLocation: 'Compartir Ubicación',
        closeTicket: 'Cerrar',
        editTicket: 'Editar',
        loadInfo: 'Cargando sus datos',
        loadRestaurant: 'Cargando...',
        getToRestaurant: 'Click aqui si ha llegado al negocio',
        carInRestaurant: 'El auto llegó al negocio',
        carArrivedInfo: 'Gracias por dejarnos saber que su auto llego',
        errorRestaurantOffline: 'Este business no está visible para el público',
        deliveryPayment: 'Pago de entrega'
      },
      payment: {
        splitPayment: 'Dividir Pago',
        splitIn: 'Dividir en',
        splitMss:
          'Las cantidades a pagar deben cubir el monto Total de la Orden. Ningún pago puede ser 0',
        splitPay: 'Pago #',
        splitToPay: 'Pagar',
        splitPayed: 'Pagado',
        tjtPayment: 'Tarjeta',
        creditPayment: 'Crédito',
        devicePayment: 'Dispositivo',
        idtechPayment: 'Moto/Swipe',
        swipePayment: 'Swipe',
        cashPayment: 'Efectivo',
        hcaPayment: 'ACH',
        housePayment: 'Cuenta Casa',
        checkPayment: 'Cheque',
        sharePayment: 'Compartir Pago',
        qrPayment: 'Qr',
        verifyMss:
          'Luego de conocer que su pago ha sido realizado, Verique el pago para guardar la orden, o Cancelar para no continuar este pago.',
        doingPayment: 'Realizando el pago',
        authorizingPayment: 'Autorizando pago',
        insuficientFunds: 'Fondos insuficientes',
        quoteExpired: 'Lo sentimos. Ha expirado el tiempo de esta propuesta',
        quoteChanged: 'La propuesta se ha modificada, se encuentra en estado: ',
        quoteAcepted: 'La propuesta ha sido Aceptada',
        goodPayment: 'Pagado',
        shareText1:
          ' compartió un enlace de pago para el pedido de comida que realizó en nuestro negocio ',
        shareText1a:
          ' compartió un enlace de pago para la reservación que realizó en nuestro negocio   ',
        shareText2:
          '. Siga el enlace a continuación para realizar el pago. ¡Gracias!'
      },
      createNew: {
        businessTemplate: 'Plantilla del negocio',
        restaurantName: 'Nombre del negocio',
        restaurantAddres: 'Dirección del negocio',
        restaurantPhone: 'Teléfono del negocio',
        restaurantEmail: 'Correo del negocio',
        restaurantZipcode: 'Zipcode del negocio',
        restaurantWeb: 'Web del negocio',
        restaurantFax: 'Fax del negocio',
        merchantName: 'Nombre del comerciante',
        merchantLastName: 'Apellido del comerciante',
        merchantAddres: 'Dirección del comerciante',
        merchantZipcode: 'ZipCode',
        merchantPhone: 'Celular del comerciante',
        merchantEmail: 'Correo del comerciante',
        merchantClerk: 'Pin del usuario (1 - 99999)',
        createTitle: 'Crear nuevo negocio en iMenuApps®',
        dataRestaurant: 'Datos del negocio',
        dataMercahnt: 'Datos del comerciante',
        restaurants: 'Negocio',
        createdMessage:
          'El negocio se ha creado correctamente. Recibirá un correo con la contraseña para acceder a la aplicación',
        clerkToLong: 'Valor de Pin excedido, máximo permitido 99999',
        clerkNotValid: 'Valor de Pin no válido',
        reciveSubscription: 'Desea recibir notificaciones de ',
        activateSubscription: 'Desea activar las notificaciones de ',
        saving: 'Guardando negocio',
        recordSaving: 'Ahorro',
        active: 'Activo',
        inactive: 'No activo',
        restaurantType: 'Tipo de Negocio',
        template: 'Plantilla',
        chooseBusinessTemplate: 'Elija la plantilla de negocios',
        select: 'Seleccione',
        temrsAndCondition: 'Términos y Condiciones',
        trialDate: '-días de prueba',
        trialMss: 'Probar por 14 días',
        business: 'Negocio',
        reservation: 'Reservación'
      },
      unsubscribe: {
        title: 'Darse de baja',
        email: 'Correo',
        unsubscribeOk: 'Su correo se ha dado de baja correctamente',
        unsubscribeFail: 'Error. Correo no encontrado',
        restaurantFail: 'Negocio no encontrado'
      },
      specialsPrice: {
        titles: 'Precios Especiales',
        title: 'Precio Especial',
        name: 'Nombre',
        type: 'Tipo',
        amount: 'Monto',
        for: 'Para',
        apply: 'Aplicar a',
        active: 'Activo',
        repite: 'Repetir',
        oneStarDate: 'Fecha y Hora de Inicio',
        oneEndDate: 'Fecha y Hora de Fin',
        weekStarDate: 'Hora de Inicio',
        weekEndDate: 'Hora de Fin',
        monthStardDat: 'Día del mes',
        annualStartDat: 'Mes y Día del año',
        activeRule:
          'Solo se aplicará una regla a la vez. El primero que se active tendrá prioridad'
      },
      credit: {
        state0: 'Solicitado',
        state1: 'Aceptado',
        state2: 'Cancelado',
        state3: 'Cerrado',
        yourCredit: 'Sus créditos',
        amount: 'Monto del crédito',
        debt: 'Deuda',
        createDate: 'Fecha de creación',
        active: 'Activo',
        dateFrom: 'Fecha inicio',
        dateTo: 'Fecha Fin',
        paymentDate: 'Fecha de pago',
        state: 'Estado',
        pendingPay: 'Pendiente de pago',
        payed: 'Pagado',
        creditpayed: 'Pago de Crédito',
        mssPay1: 'El cliente ',
        mssPay2: 'ha realizado un pago del crédito ',
        mssPay3: 'por un monto '
      }
    }
}